import React, { Fragment } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Loader from "../components/Loader";
import PageHeader from "../components/PageHeader";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneInput from "react-phone-input-2";

import {
  SITENAMEALIAS,
  WEBSERVICE,
  ASSETS,
  CAPTCHASITEKEY,
  SITENAME,
} from "../utils/init";
import { useNavigate } from "react-router-dom";
import { render } from "react-dom";
import { Link, withRouter } from "react-router-dom";
import {
  SaveBasicUserSettings,
  SaveTwoFactorSettings,
  FetchUserSettings,
  ChangePassword,
  FetchMerchantSettings,
  SetNotifiEmail,
  EmailCheck,
  FetchMerchantProfile,
  FetchAllIndustry,
  FetchActivatedVolume,
  FetchMerchantStatus,
  UpdateVolumeId,
  UploadFile,
  AddMerchantProfile,
  GetMerchantSettings,
  SetMerchantSettings,
  googleTwoFactorAuth,
  checkTwoFactorAuth,
  getSignUpPhoneOtp,
  verifyRegistredPhoneNo,
  phoneAuthEnable,
  phoneAuthDisable,
  getSignUpEmailOtp,
  sendOtpForTwoFa,
  sendOtpInRegNo,
  checkTwoFactorAuthSettings,
  FetchUsdBtcLedgerAmount,
  PurgeData,
  sendEmailOtpForUpdate,
  updateMerchantEmail,
  changeMobileNo,
  getAuthToken,
  getAuthUuid,
} from "../utils/service";
import { Modal, Form, Button } from "react-bootstrap";
import QRCode from "react-qr-code";
import {
  _isValidPhoneNo,
  _isValidZipCode,
  showToast,
  showHttpError,
  handleCurrencyDetiails,
  handleDynamicCurrencyDetiails,
  formatAmount,
  currentPageAccess,
} from "../utils/library";
import axios from "axios";
import CaptchaModal from "./CaptchaModal";
import PaybitoCaptcha from "../components/PaybitoCaptcha";
import Swal from "sweetalert2";

class UserSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      showCaptchaModal: false,
      showCaptchaModalSecond: false,
      noOfItemsPerPage: 10,
      showAppSettings: false,
      showUserSettings: true,
      isTwoFactorAuthChecked: false,
      qrcodeValue: "",
      qrcode: "",
      isInputQrCodeAvailable: true,
      firstName: "",
      lastName: "",
      phoneNo: "",
      currentPassword: "",
      newPassword: "",
      reTypePassword: "",
      merchantName: "",
      merchantWebsite: "",
      merchantIndustry: "",
      supportPhone: "",
      supportEmail: "",
      dailyTxnLimit: "",
      monthlyTxnLimit: "",
      sendNotificationTo: "",
      showOrderSettingsModal: false,
      showMerchantSettingsModal: false,
      showIncreaseVolumeModal: false,
      showAutomaticExceptionHandlingModal: false,
      googleAuthModal: false,
      isGoogleAuthChecked: false,
      showTaxModal: false,
      sendNotificationToRegisteredAddress: true,
      sendNotificationToDifferentAddress: false,
      newNotificationEmail: "",
      industryList: [],
      currentPlanTxnCharges: [],
      plans: [],
      assets: [],
      selectedIndustryForMerchantEdit: "",
      isPreferedEmailChecked: true,
      isPreferedWebsiteChecked: false,
      isAcceptBtcAtRetailChecked: false,
      isDisplayAddressChecked: false,
      isDifferenAddressChecked: false,
      isLightPlanApplied: false,
      isBasicPlanApplied: false,
      isBusinessPlanApplied: false,
      isEnterprisePlanApplied: false,
      selectedPlanIdForApply: "",
      ein: "",
      einDoc: null,
      ownerIdentityDoc: null,
      inCorpDoc: null,
      businessAddressDoc: null,
      website: "",
      mAddress1: "",
      mAddress2: "",
      mCity: "",
      mState: "",
      mCountry: "",
      mZip: "",
      mOrganizationName: "",
      mDesc: "",
      mIndustry: "",
      mWebsite: "",
      mSupportPhone: "",
      mSupportEmail: "",
      selectedCurrencyIdForAutomaticExceptionHandling: "2",
      isAutomaticAcceptUnderpayment: false,
      underPaymentToleranceLimit: "",
      isAutomaticAcceptOverpayment: false,
      overPaymentToleranceLimit: "",
      showChangePasswordAuthModal: false,
      changePasswordAuthCode: "",
      isChangePswdAuthCodeBtn: true,
      changePswdOtpTimerTxt: "",
      showChangePswdOtpTimer: false,
      changePswdConfirmBtnDisabled: true,
      sendChangePswdOtpBtn: true,
      basicSettingCaptchaValue: "",
      isBasicSettingBtnEnable: false,
      securityCaptchaValue: "",
      isSecuritySettingBtnEnabled: false,
      resetPswdCaptchaValue: "",
      savePasswordResetBtnEnabled: false,
      sendOtpBtnForPhnoChange: true,
      isPhoneNumberReadonly: true,
      isChangePhnoBtnDisable: false,
      changePhnoModal: false,
      newPhnoModal: false,
      countryCode: "",
      countryCode2: "",
      sendOtpInRegnoBtn: true,
      sendOtpInNewnoBtn: true,
      //for registred otp modal
      timertxt: "",
      secondStatusCheckForOtpTimer: false,
      isTimerShow: false,
      btnProceedToNewNo: false,

      //for new number otp modal
      timertxt2: "",
      secondStatusCheckForNewOtpTimer: false,
      isTimerShow2: false,
      btnUpdateToNewNo: false,

      isPhoneAuthChecked: false,

      isTwoFactorChecked: false,
      showEmailOtpTimer: false,
      emailOtpTimerTxt: "",
      sendEmailOtpBtn: false,
      proceedEmailOtpBtn: true,
      qrCodeValFor2fa: "",
      qrCodeInput: "",
      verifyQrCodeBtn: true,
      scannerModal: false,
      qrcodeval: "",
      googleAuthKey: "",

      sendEmailOtpFor2faBtn: false,
      showTimerForChangPhno: false,
      otptimertxt: false,
      secondStatusCheckForMobileOtpTimer: false,
      sendOtpOldNo: false,
      emailOtpFor2fa: "",
      emailOtpFor2faRefError: "",

      // Email Update states
      currentEmailForUpdate: "",
      newEmailForUpdate: "",
      emailUpdateOtpModal: false,
      oldEmailOtp: "",
      newEmailOtp: "",
      sendOtpOldEmailBtn: false,
      showOldEmailOtpTimer: false,
      oldEmailOtpTimerTxt: "",
      newEmailError: "",

      orgNameError: false,
      btnUpdateSetting: false,
      descriptionError: false,
      websiteError: false,
      phoneError: false,
      emailIdError: false,
      address1_error: false,
      address2_error: false,
      cityError: false,
      stateError: false,
      zipcodeError: false,

      registeredPhnoOtp: "",
      captcha: "",
      sessionId: "",
      showCaptchaModalDelete: false,
      apiKeyDiv: true,
      Themecolor: "Dark", // or 'Light'
      apitype: [],
      apikey: "",
      secretkey: "",
      apikeylist: [],
      settingsObj: { name: "" },
      ipRestrictStatus: 0,
      ipListTemp: [],
      apiKeyDataForEdit: null,
      gaOtpForEdit: "",
      emailOtpForEdit: "",
      isGetCodeButtonDisabled: false,
      createApiOtpCountdown: 60,
      messageotp: "",
      deleteapikeyObj: {},
      gaOtpForDelete: "",
      emailOtpForDelete: "",

      twoFactorAPIKeyModal: false,
      newAPIKeyName: "",

      apiKey: "abc123xyz456",
      apiSecret: "secret789xyz321",
      permissions: {
        Read: true,
        Dashboard: false,
        "Payment Button": false,
        "RECURRING PAYMENT": false,
        "EMAIL BILLING": false,
        "HOSTED CATALOG": false,
        INSIGHTS: false,
      },
      newApiPermissions: {
        isDashboard: 0,
        isProductsPrice: 0,
        isCreatePayment: 0,
        isTransactions: 0,
        isSettlements: 0,
        isAnalytics: 0,
        isTeam: 0,
        isPaymentSetup: 0,
        isCheckoutTemplates: 0,
        isLimits: 0,
        isPaymentTolerance: 0,
      },
      showEditModal: false,
      selectedApiKey: null, // the API key object to be edited
      ipRestrictStatus: 0, // 0: Unrestricted, 1: Restricted
      ipListTemp: [],
      twoFactorAPIKeyModalStatus: "",
      newApiKeyGen: "",
      newApiSecretKeyGen: "",
      deletePayload: {},
    };

    this.firstNameRef = React.createRef;
    this.lastNameRef = React.createRef;
    this.phoneRef = React.createRef;
    this.qrCodeValueRef = React.createRef();
    this.changePasswordAuthCodeRef = React.createRef();
    this.basicSettingRecaptchaRef = React.createRef();
    this.securitySettingRecaptchaRef = React.createRef();
    this.passwordChangeRecaptchaRef = React.createRef();
    this.deleteRecaptchaRef = React.createRef();
    this.registeredPhnoOtpRef = React.createRef();
    this.newPhnoOtpRef = React.createRef();
    this.googleAuthOtpRef = React.createRef();
    this.emailOtpFor2faRef = React.createRef();
    this.oldEmailOtpRef = React.createRef();
    this.newEmailOtpRef = React.createRef();
    this.twofaqrcodevalue = React.createRef();
    this.emailOtpForTwoFaOff = React.createRef();
    this.gaCodeFor2faOff = React.createRef();
    this.copyTxtRef = React.createRef();
  }

  /* Method defination for toggling settings */
  handleSettingsToggle = (param) => {
    if (param == "user") {
      this.setState({
        showUserSettings: true,
        showAppSettings: false,
      });
      this.renderUserSettingsData();
    } else {
      this.setState({
        showUserSettings: false,
        showAppSettings: true,
      });
      this.renderMerchantSettings();
    }
  };

  /* Method defination for retrieving merchant status */
  getMerchantStatus = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });
    FetchMerchantStatus(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", "Order Settings Updated Successfully");
            this.renderMerchantSettings();
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          console.log("err", err);
          showHttpError(err);
        }.bind(this)
      );
  };

  /* Method defination for checking email */
  handleCheckEmail = (e) => {
    if (e.target.value != "") {
      let payload = {
        email: e.target.value,
      };
      this.setState({ showLoader: true });
      EmailCheck(payload)
        .then(
          function (res) {
            this.setState({ showLoader: false });
            let response = res.data[0];
            if (response.error != "0") {
              this.setState(
                {
                  newNotificationEmail: "",
                },
                () => {
                  showToast("error", response.error_msg);
                  e.target.value = "";
                }
              );
            } else {
              this.setState({
                newNotificationEmail: e.target.value,
              });
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            this.setState({ showLoader: false });
            console.log("err", err);
            showHttpError(err);
          }.bind(this)
        );
    }
  };

  /* Method defination for updating order settings */
  handleUpdateOrderSetting = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    if (this.state.sendNotificationToDifferentAddress) {
      console.log("IF ", this.state.newNotificationEmail);
      payload.notification_email = this.state.newNotificationEmail;
    } else {
      console.log("ELSE ", this.state.sendNotificationTo);
      payload.notification_email = this.state.sendNotificationTo;
    }
    this.setState({ showLoader: true });
    SetNotifiEmail(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", "Order Settings Updated Successfully");
            this.renderMerchantSettings();
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          console.log("err", err);
          showHttpError(err);
        }.bind(this)
      );
  };

  /* Method defination for change password API call */
  handleChangePassword = async () => {
    if (
      this.state.currentPassword != "" &&
      this.state.newPassword != "" &&
      this.state.reTypePassword != ""
    ) {
      try {
        const { token } =
          await this.passwordChangeRecaptchaRef.current.verify();
        this.handleCaptchaSubmitSecond(token);
      } catch (err) {
        showToast("error", err.message || "Captcha verification failed");
      }
    } else {
      showToast(
        "error",
        "Please provide current,new and retype password field data"
      );
    }
  };
  handleCaptchaSubmitSecond = (captcha) => {
    this.setState({ captcha: captcha });
    if (
      localStorage.getItem(SITENAMEALIAS + "_is_google_auth_enabled") === "1"
    ) {
      this.setState({
        showChangePasswordAuthModal: true,
        changePswdConfirmBtnDisabled: true,
        sendChangePswdOtpBtn: true,
      });
      // this.sendOtpForChangePassword();
    } else {
      showToast("error", "Please turn on Google Authentication in Settings.");
    }
  };

  setStateHandler = (newState) => {
    this.setState(newState);
  };
  handleDeleteMyData = async () => {
    try {
      const { token } = await this.deleteRecaptchaRef.current.verify();
      this.handleCaptchaSubmitDelete(token);
    } catch (err) {
      showToast("error", err.message || "Captcha verification failed");
    }
  };

  handleCaptchaSubmitDelete = (captcha) => {
    Swal.fire({
      title: "Delete Account Data",
      html: `<div style="text-align:center; padding: 10px 0;">
        <div style="width:64px; height:64px; border-radius:50%; background:#FFF3E0; display:inline-flex; align-items:center; justify-content:center; margin-bottom:16px;">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#E65100" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 6h18"/>
            <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6"/>
            <path d="M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2"/>
            <line x1="10" y1="11" x2="10" y2="17"/>
            <line x1="14" y1="11" x2="14" y2="17"/>
          </svg>
        </div>
        <p style="color:#555; font-size:14px; margin:0;">Are you sure you want to delete your account data?</p>
      </div>`,
      showCancelButton: true,
      confirmButtonColor: "#E65100",
      cancelButtonColor: "#757575",
      confirmButtonText: "Yes, Continue",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      customClass: {
        popup: "swal2-popup-custom",
        confirmButton: "swal2-confirm-custom",
        cancelButton: "swal2-cancel-custom",
      },
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: "Permanent Deletion",
          html: `<div style="text-align:center; padding: 10px 0;">
            <div style="width:64px; height:64px; border-radius:50%; background:#FFEBEE; display:inline-flex; align-items:center; justify-content:center; margin-bottom:16px;">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#C62828" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
            </div>
            <p style="color:#C62828; font-weight:600; font-size:14px; margin:0 0 8px;">This action is irreversible.</p>
            <p style="color:#555; font-size:13px; margin:0; line-height:1.5;">Your data will be permanently deleted and you will lose access to your account immediately.</p>
          </div>`,
          showCancelButton: true,
          confirmButtonColor: "#C62828",
          cancelButtonColor: "#757575",
          confirmButtonText: "Delete My Data",
          cancelButtonText: "Go Back",
          reverseButtons: true,
          customClass: {
            popup: "swal2-popup-custom",
            confirmButton: "swal2-confirm-custom",
            cancelButton: "swal2-cancel-custom",
          },
        }).then((result) => {
          if (result.value) {
            let payload = {
              merchant_uuid: getAuthUuid(),
              gRecaptchaResponse: captcha,
            };
            this.setState({ showLoader: true });
            PurgeData(payload).then(
              function (res) {
                let response = res.data[0];
                if (response.error != "0") {
                  showToast("error", response.error_msg);
                } else {
                  showToast("success", response.error_msg);
                  this.handleLogout();
                }
              }.bind(this)
            );
          }
        });
      }
    });
  };

  isPasswordAuthCheck = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      current_password: this.state.currentPassword,
      new_password: this.state.newPassword,
      gRecaptchaResponse: this.state.captcha,
    };
    if (this.state.changePasswordAuthCode != "") {
      payload["google_factor_otp"] =
        this.changePasswordAuthCodeRef.current.value;
      ChangePassword(payload)
        .then(
          function (res) {
            this.setState({ showLoader: false });
            let response = res.data[0];
            if (response.error != "0") {
              showToast("error", response.error_msg);
            } else {
              showToast("success", "Password changed successfully");
              this.setState({
                currentPassword: "",
                newPassword: "",
                reTypePassword: "",
                changePasswordAuthCode: "",
                showChangePasswordAuthModal: false,
              });
              window.location.reload();
              // this.changePasswordAuthCodeRef.current.value = ""
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            this.setState({ showLoader: false });
            console.log("err", err);
            showHttpError(err);
          }.bind(this)
        );
    }
  };

  sendOtpForChangePassword = () => {
    let payload = {
      email: localStorage.getItem(SITENAMEALIAS + "_email"),
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    sendOtpForTwoFa(payload)
      .then(
        function (res) {
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", "OTP sent to your registered email");
            this.setState({
              showChangePswdOtpTimer: true,
              sendChangePswdOtpBtn: true,
              changePswdConfirmBtnDisabled: true,
            });
            localStorage.setItem("secstatuscheckForChangePswdTimer", "true");
            let count = "120";
            localStorage.setItem("cdotpforchangepassword", count);
            this.startTimerForChangePswd(count);
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  startTimerForChangePswd = (i) => {
    let count = i;
    this.setState({ changePswdOtpTimerTxt: count }, () => {
      let downloadTimer = setInterval(() => {
        if (count <= 1) {
          clearInterval(downloadTimer);
          this.setState({
            showChangePswdOtpTimer: false,
            changePswdConfirmBtnDisabled: false,
            sendChangePswdOtpBtn: false,
          });
          localStorage.setItem("cdotpforchangepassword", "");
          localStorage.setItem("secstatuscheckForChangePswdTimer", "false");
        }
        count -= 1;
        localStorage.setItem("cdotpforchangepassword", count);
        this.setState({
          changePswdOtpTimerTxt: localStorage.getItem("cdotpforchangepassword"),
        });
      }, 1000);
    });
  };

  /* Method defination for rendering user settings data */
  renderUserSettingsData = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });

    FetchUserSettings(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            //    this.firstNameRef.current.value = response.first_name;
            //    this.lastNameRef.current.value = response.last_name;
            //    this.phoneRef.current.value = response.phone_no;
            this.setState({
              firstName: response.first_name,
              lastName: response.last_name,
              phoneNo: response.phone_no,
              countryCode: response.country_code,
              currentPassword: "",
            });
            localStorage.setItem(
              SITENAMEALIAS + "_registredphno",
              response.phone_no
            );
            localStorage.setItem("exit_2fa_key", response.EXIST_2FA_KEY);

            // if (response.two_factor_auth_enabled == "0") {
            //   this.setState({
            //     isTwoFactorAuthChecked: false,
            //   });
            // } else {
            //   this.setState({
            //     isTwoFactorAuthChecked: true,
            //   });
            // }
            // if (response.google_auth_enabled == "0") {
            //   this.setState({
            //     isGoogleAuthChecked: false,
            //   });
            // } else {
            //   this.setState({
            //     isGoogleAuthChecked: true,
            //   });
            // }
            if (response.google_auth_enabled == "0") {
              this.setState({
                isTwoFactorChecked: false,
              });
            } else {
              this.setState({
                isTwoFactorChecked: true,
              });
            }
            if (response.phone_auth_enabled == "0") {
              this.setState({
                isPhoneAuthChecked: false,
              });
            } else {
              this.setState({
                isPhoneAuthChecked: true,
              });
            }
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          console.log("err", err);
          showHttpError(err);
        }.bind(this)
      );
  };
  /* Method defination for rendering merchant settings */
  renderMerchantSettings = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });

    FetchMerchantSettings(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            let currentPlanTxnCharges = response.TXN_CHARGES;
            let txnChargesArr = currentPlanTxnCharges.split(",");
            //console.log(txnChargesArr);
            let txnChargeList = [];
            for (let i = 0; i < txnChargesArr.length; i++) {
              let iter = txnChargesArr[i];
              let iterArr = iter.trim().split(" ");
              // console.log(iterArr)
              let obj = { asset: iterArr[0], charge: iterArr[1] };
              txnChargeList.push(obj);
            }
            //console.log(txnChargeList)
            this.setState({
              currentPlanTxnCharges: txnChargeList,
              plans: response.plans,
              merchantWebsite: response.website,
              merchantName: response.organization_name,
              merchantIndustry: response.industry_name,
              supportEmail: response.support_email,
              supportPhone: response.support_phone,
              sendNotificationTo: response.notification_email,
              dailyTxnLimit: response.daily_amount_cap,
              monthlyTxnLimit: response.monthly_transaction_cap,
            });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          console.log("err", err);
          showHttpError(err);
        }.bind(this)
      );
  };

  /* Method Defination for saving user settings */
  handleSaveBasicUserSettings = async () => {
    if (
      this.state.firstName != "" &&
      this.state.lastName != "" &&
      this.state.phoneNo != ""
    ) {
      try {
        const { token } = await this.basicSettingRecaptchaRef.current.verify();
        this.handleCaptchaSubmit(token);
      } catch (err) {
        showToast("error", err.message || "Captcha verification failed");
      }
    } else {
      showToast("error", "Please provide first name, last name and phone no.");
    }
  };

  handleCaptchaSubmit = (captcha) => {
    let payload = {
      merchant_f_name: this.state.firstName,
      merchant_l_name: this.state.lastName,
      phone: this.state.phoneNo,
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      gRecaptchaResponse: captcha,
    };
    SaveBasicUserSettings(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data;
          let errorObj = response[response.length - 1];
          if (errorObj.error != "0") {
            showToast("error", errorObj.error_msg);
          } else {
            this.renderUserSettingsData();
            // if(this.state.isTwoFactorAuthChecked == true || this.state.isGoogleAuthChecked == true){
            //   this.handleLogout();
            // }
            // this.handleLogout();
            this.setState({
              isBasicSettingBtnEnable: true,
            });
            showToast("success", "Settings saved successfully");
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  setStateHandler = (newState) => {
    this.setState(newState);
  };

  handleLogout = () => {
    localStorage.removeItem(SITENAMEALIAS + "_merchant_id");
    localStorage.removeItem(SITENAMEALIAS + "_first_name");
    localStorage.removeItem(SITENAMEALIAS + "_last_name");
    localStorage.removeItem(SITENAMEALIAS + "_email");
    localStorage.removeItem(SITENAMEALIAS + "_paybito_userid");
    localStorage.removeItem(SITENAMEALIAS + "_paybito_id");
    localStorage.clear();
    // this.props.history.push("/");
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };

  //  COPY TEXT TO CLIPBOARD
  copyTextToClipboard = () => {
    const textToCopy = this.copyTxtRef.current.innerText;
    navigator.clipboard.writeText(textToCopy);
  };
  /* Method defination for getting all merchant data */
  renderMerchantProfileData = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });

    FetchMerchantProfile(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            console.log(response);
            this.setState({
              selectedIndustryForMerchantEdit: response.industry_id,
              mOrganizationName: response.organization_name,
              mDesc: response.organization_desc,
              mWebsite: response.website,
              mSupportPhone: response.support_phone,
              mSupportEmail: response.support_email,
              mAddress1: response.inv_address_line_1,
              mAddress2: response.inv_address_line_2,
              mCity: response.inv_city,
              mState: response.inv_state,
              mCountry: response.inv_country,
              mZip: response.inv_zip,
            });

            if (response.display_address_on_bill == 0) {
              // alert(response.display_address_on_bill)
              this.setState({
                isDisplayAddressChecked: false,
              });
            } else {
              this.setState({
                isDisplayAddressChecked: true,
              });
            }

            if (response.separate_invoice_location == 0) {
              // alert('false')
              this.setState({
                isDifferenAddressChecked: false,
              });
            } else {
              // alert('true')
              this.setState({
                isDifferenAddressChecked: true,
              });
            }

            console.log("retail locationo:", response.bitcoin_retail_location);
            if (response.bitcoin_retail_location == "0") {
              // alert('false')
              this.setState({
                isAcceptBtcAtRetailChecked: false,
              });
            } else {
              // alert('true')
              this.setState({
                isAcceptBtcAtRetailChecked: true,
              });
            }
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          console.log(err);
          showHttpError(err);
        }.bind(this)
      );
  };

  /* Method defination for fetch activated volume data */
  renderActivatedVolumeData = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });
    FetchActivatedVolume(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            if (response.volume_id == "1") {
              if (response.requested_volume_status == "33") {
                showToast(
                  "error",
                  "Your volume change request to Light Plan has been declined by admin."
                );
              } else {
                this.setState({
                  isLightPlanApplied: true,
                  isBasicPlanApplied: false,
                  isBusinessPlanApplied: false,
                });
              }
            } else if (response.volume_id == "2") {
              if (response.requested_volume_status == "33") {
                showToast(
                  "error",
                  "Your volume change request to Basic Plan has been declined by admin."
                );
              } else {
                this.setState({
                  isLightPlanApplied: false,
                  isBasicPlanApplied: true,
                  isBusinessPlanApplied: false,
                });
              }
            } else if (response.volume_id == "3") {
              if (response.requested_volume_status == "33") {
                showToast(
                  "error",
                  "Your volume change request to Business Plan has been declined by admin."
                );
              } else {
                this.setState({
                  isLightPlanApplied: false,
                  isBasicPlanApplied: false,
                  isBusinessPlanApplied: true,
                });
              }
            }
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          console.log(err);
          showHttpError(err);
        }.bind(this)
      );
  };

  handleOrgName = (e) => {
    let elm = e.target.value;
    let regex = /^[a-zA-Z0-9 ]{2,50}$/;
    if (regex.test(elm)) {
      this.setState({
        orgNameError: false,
        btnUpdateSetting: false,
      });
    } else {
      this.setState({
        orgNameError: true,
        btnUpdateSetting: true,
        mOrganizationName: "",
      });
    }
  };

  handleDiscription = (e) => {
    let elm = e.target.value;
    let regex = /^[a-zA-Z0-9 ]{2,50}$/;
    if (regex.test(elm)) {
      this.setState({
        descriptionError: false,
        btnUpdateSetting: false,
      });
    } else {
      this.setState({
        descriptionError: true,
        btnUpdateSetting: true,
        mDesc: "",
      });
    }
  };

  handleWebsite = (e) => {
    let elm = e.target.value;
    let regex =
      /^(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9_-]+\.[a-zA-Z]{2,}(?:\/[a-zA-Z0-9#?=&\/_-]+)*$/;
    if (regex.test(elm)) {
      this.setState({
        websiteError: false,
        btnUpdateSetting: false,
      });
    } else {
      this.setState({
        websiteError: true,
        btnUpdateSetting: true,
        mWebsite: "",
      });
    }
  };
  isValidWebsite = (e) => {
    let elm = e.target.value;
    let regex =
      /^(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9_-]+\.[a-zA-Z]{2,}(?:\/[a-zA-Z0-9#?=&\/_-]+)*$/;
    if (regex.test(elm)) {
      this.setState({
        isWebsiteError: false,
        btnDisabled: false,
      });
    } else {
      this.setState({
        isWebsiteError: true,
        btnDisabled: true,
        website: "",
      });
    }
  };

  handlePhoneNumber = (e) => {
    let elm = e.target.value;
    let regex = /^(\+)?\d{1,15}$/;
    if (regex.test(elm)) {
      this.setState({
        phoneError: false,
        btnUpdateSetting: false,
      });
    } else {
      this.setState({
        phoneError: true,
        btnUpdateSetting: true,
        mSupportPhone: "",
      });
    }
  };
  handleEmailId = (e) => {
    let elm = e.target.value;
    let regex = /^[a-zA-Z0-9._%+-]{1,30}@[a-zA-Z0-9-]{1,30}\.[a-zA-Z]{2,}$/;
    if (regex.test(elm)) {
      this.setState({
        emailIdError: false,
        btnUpdateSetting: false,
      });
    } else {
      this.setState({
        emailIdError: true,
        btnUpdateSetting: true,
        mSupportEmail: "",
      });
    }
  };

  handleAddress1 = (e) => {
    let elm = e.target.value;
    let regex = /^[a-zA-Z0-9\s\/\.,-]+$/;
    if (regex.test(elm)) {
      this.setState({
        address1_error: false,
        btnUpdateSetting: false,
      });
    } else {
      this.setState({
        address1_error: true,
        btnUpdateSetting: true,
        mAddress1: "",
      });
    }
  };

  handleAddress2 = (e) => {
    let elm = e.target.value;
    let regex = /^[a-zA-Z0-9\s\/\.,-]+$/;
    if (regex.test(elm)) {
      this.setState({
        address2_error: false,
        btnUpdateSetting: false,
      });
    } else {
      this.setState({
        address2_error: true,
        btnUpdateSetting: true,
        mAddress2: "",
      });
    }
  };

  handleCity = (e) => {
    let elm = e.target.value;
    let regex = /^[A-Za-z ]+$/;
    if (regex.test(elm)) {
      this.setState({
        cityError: false,
        btnUpdateSetting: false,
      });
    } else {
      this.setState({
        cityError: true,
        btnUpdateSetting: true,
        mCity: "",
      });
    }
  };

  handleState = (e) => {
    let elm = e.target.value;
    let regex = /^[A-Za-z ]+$/;
    if (regex.test(elm)) {
      this.setState({
        stateError: false,
        btnUpdateSetting: false,
      });
    } else {
      this.setState({
        stateError: true,
        btnUpdateSetting: true,
        mState: "",
      });
    }
  };

  handleZipcode = (e) => {
    let elm = e.target.value;
    let regex = /^[a-zA-Z0-9 ]{1,15}$/;
    if (regex.test(elm)) {
      this.setState({
        stateError: false,
        btnUpdateSetting: false,
      });
    } else {
      this.setState({
        stateError: true,
        btnUpdateSetting: true,
        mZip: "",
      });
    }
  };

  /* Method defination for handling update merchant profile settings data */
  handleUpdateMerchantProfileSettings = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      organization_name: this.state.mOrganizationName,
      organization_desc: this.state.mDesc,
      industry_id: this.state.selectedIndustryForMerchantEdit,
      website: this.state.mWebsite,
      support_phone: this.state.mSupportPhone,
      support_email: this.state.mSupportEmail,
    };

    if (this.state.isPreferedEmailChecked) {
      payload["preffered_contact_method"] = "email";
    } else {
      payload["preffered_contact_method"] = "website";
    }
    if (this.state.isAcceptBtcAtRetailChecked == true) {
      payload["bitcoin_retail_location"] = "1";
    } else {
      payload["bitcoin_retail_location"] = "0";
    }
    if (this.state.isDisplayAddressChecked == true) {
      payload["display_address_on_bill"] = 1;
    } else {
      payload["display_address_on_bill"] = 0;
    }
    if (
      this.state.isDifferenAddressChecked == true &&
      this.state.mAddress1 != "" &&
      this.state.mCity != "" &&
      this.state.mState != "" &&
      this.state.mZip != "" &&
      this.state.mCountry != ""
    ) {
      payload["separate_invoice_location"] = 1;
      payload["inv_address_line_1"] = this.state.mAddress1;
      payload["inv_address_line_2"] = this.state.mAddress2;
      payload["inv_city"] = this.state.mCity;
      payload["inv_state"] = this.state.mState;
      payload["inv_country"] = this.state.mCountry;
      payload["inv_zip"] = this.state.mZip;
    } else {
      // alert('false')
      payload["separate_invoice_location"] = 0;
      payload["inv_address_line_1"] = "";
      payload["inv_address_line_2"] = "";
      payload["inv_city"] = "";
      payload["inv_state"] = "";
      payload["inv_country"] = "";
      payload["inv_zip"] = "";
    }
    this.setState({ showLoader: true });
    AddMerchantProfile(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", "Details updated successfully");
            this.setState({ showMerchantSettingsModal: false }, () => {
              this.renderMerchantProfileData();
              this.renderMerchantSettings();
            });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };
  /* Method defination for fetching all industry */
  renderAllIndustry = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });

    FetchAllIndustry(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data;
          this.setState({
            industryList: response,
          });
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  /* Method defination for applying a plan */
  handleApplyPlan = () => {
    console.log(this.state.ein, this.state.einDoc);
    if (this.state.ein != "" && this.state.einDoc != null) {
      let fd = new FormData();
      fd.append("file_1", this.state.einDoc);
      fd.append("file_type_1", 1);
      fd.append("file_2", this.state.ownerIdentityDoc);
      fd.append("file_type_2", 3);
      fd.append("file_3", this.state.businessAddressDoc);
      fd.append("file_type_3", 4);
      fd.append("file_4", this.state.inCorpDoc);
      fd.append("file_type_4", 5);
      fd.append(
        "merchant_id",
        localStorage.getItem(SITENAMEALIAS + "_merchant_id")
      );
      this.setState({ showLoader: true });

      UploadFile(fd)
        .then(
          function (res) {
            this.setState({ showLoader: false });
            let response = res.data[0];
            if (response.error != "0") {
              showToast("error", response.error_msg);
            } else {
              let payload = {
                merchant_id: localStorage.getItem(
                  SITENAMEALIAS + "_merchant_id"
                ),
                volume_id: this.state.selectedPlanIdForApply,
                tax_id: this.state.ein,
                website: this.state.website,
              };

              this.setState({ showLoader: true });

              UpdateVolumeId(payload)
                .then(
                  function (res) {
                    this.setState({ showLoader: false });
                    let response = res.data[0];
                    if (response.error != "0") {
                      showToast("error", response.error_msg);
                    } else {
                      showToast("success", "Plan applied successfully");
                      setTimeout(() => {
                        window.location.reload();
                      }, 3000);
                    }
                  }.bind(this)
                )
                .catch(
                  function (err) {
                    this.setState({ showLoader: false });
                    showHttpError(err);
                  }.bind(this)
                );
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            this.setState({ showLoader: false });
            showHttpError(err);
          }.bind(this)
        );
    } else {
      showToast("error", "Please provide valid EIN and EIN document");
    }
  };

  /* Method defination for rendering settings for automatic exception handling */
  renderSettingsForAutomaticExceptionHandling = (currencyId) => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      currency_id: currencyId,
    };
    this.setState({ showLoader: true });
    GetMerchantSettings(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            let acceptOverPayment = false;
            let acceptUnderPayment = false;
            if (
              response.accept_overpayments != "" &&
              response.accept_overpayments != null &&
              response.accept_overpayments != "no"
            ) {
              acceptOverPayment = true;
            } else {
              acceptOverPayment = false;
            }
            if (
              response.accept_underpayments != "" &&
              response.accept_underpayments != null &&
              response.accept_underpayments != "no"
            ) {
              acceptUnderPayment = true;
            } else {
              acceptUnderPayment = false;
            }
            this.setState({
              underPaymentToleranceLimit: formatAmount(
                response.underpayment_tolerance,
                5
              ),
              overPaymentToleranceLimit: formatAmount(
                response.overpayment_tolerance,
                5
              ),
              isAutomaticAcceptOverpayment: acceptOverPayment,
              isAutomaticAcceptUnderpayment: acceptUnderPayment,
            });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  /* Method defination for saving automatic exception handling data */
  handleAutomaticExceptionHandling = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      currency_id: this.state.selectedCurrencyIdForAutomaticExceptionHandling,
      overpayment_tolerance: formatAmount(
        this.state.overPaymentToleranceLimit,
        5
      ),
      underpayment_tolerance: formatAmount(
        this.state.underPaymentToleranceLimit,
        5
      ),
    };
    if (this.state.isAutomaticAcceptUnderpayment) {
      payload["accept_underpayments"] = "yes";
    } else {
      payload["accept_underpayments"] = "no";
    }
    if (this.state.isAutomaticAcceptOverpayment) {
      payload["accept_overpayments"] = "yes";
    } else {
      payload["accept_overpayments"] = "no";
    }

    this.setState({ showLoader: true });
    SetMerchantSettings(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            this.setState(
              {
                showAutomaticExceptionHandlingModal: false,
              },
              () => {
                showToast(
                  "success",
                  "Automatic Exceptional Handling data saved successfully"
                );
              }
            );
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  handleOnCaptchaChange = (value) => {
    console.log("Captcha Value", value);
    this.setState(
      {
        basicSettingCaptchaValue: value,
      },
      () => {
        // this.handleVerifyCapthcha(value);
        this.setState({
          isBasicSettingBtnEnable: true,
        });
      }
    );
  };

  onSecureCaptchaChange = (value) => {
    console.log("Captcha Value", value);
    this.setState(
      {
        securityCaptchaValue: value,
      },
      () => {
        // this.handleVerifyCapthcha(value);
        this.setState({
          isSecuritySettingBtnEnabled: true,
        });
      }
    );
  };
  onPswdCaptchaChange = (value) => {
    console.log("Captcha Value", value);
    this.setState(
      {
        resetPswdCaptchaValue: value,
      },
      () => {
        // this.handleVerifyCapthcha(value);
        this.setState({
          savePasswordResetBtnEnabled: true,
        });
      }
    );
  };
  getTwoFactorAuthVerify = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };

    if (this.state.isGoogleAuthChecked == false) {
      googleTwoFactorAuth(payload)
        .then(
          function (res) {
            var response = res.data[0];
            if (response.error != "0") {
              showToast("error", response.error_msg);
            } else {
              console.log(response.google_auth_key);
              // var auth_key = response.google_auth_key
              var _email = encodeURIComponent(localStorage.getItem(SITENAMEALIAS + "_email"));
              var _issuer = encodeURIComponent(localStorage.getItem(SITENAMEALIAS + "_exchange"));
              var twoFactorAuthKey =
                "otpauth://totp/" +
                _issuer + ":" + _email +
                "?secret=" +
                response.google_auth_key +
                "&issuer=" +
                _issuer;
              this.setState({
                googleAuthModal: true,
                qrcodeValue: twoFactorAuthKey,
                isGoogleAuthChecked: true,
                googleAuthKey: response.google_auth_key,
              });
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            this.setState({ showLoader: false });
            showHttpError(err);
          }.bind(this)
        );
    } else {
      this.setState({
        isGoogleAuthChecked: false,
      });
    }
  };

  getTwoFactorAuthVerifcation = () => {
    if (this.twofaqrcodevalue.current.value != "") {
      let payload = {
        merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
        google_auth_enabled: "1",
        google_factor_otp: this.twofaqrcodevalue.current.value,
      };

      SaveTwoFactorSettings(payload).then(
        function (res) {
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", response.error_msg);
            this.handleLogout();
          }
        }.bind(this)
      );
    } else {
      this.setState({
        isGoogleAuthChecked: false,
      });
    }
  };

  googleAuthOtpVerification = () => {
    let payload = {
      email: localStorage.getItem(SITENAMEALIAS + "_email"),
      otp: this.qrCodeValueRef.current.value,
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      // password: localStorage.getItem(SITENAMEALIAS + "_password"),
    };
    checkTwoFactorAuthSettings(payload)
      .then(
        function (res) {
          let response = res.data[0];
          if (response.error != "0") {
            console.log("not working");
            showToast("error", response.error_msg);
            // this.qrCodeValueRef.current.value = "";
            this.setState({
              googleAuthModal: false,
              isGoogleAuthChecked: false,
            });
            // alert(response.error_msg)
            window.location.reload();
          } else {
            // let payload = {
            //   merchant_f_name : localStorage.getItem(SITENAMEALIAS + '_first_name'),
            //   merchant_l_name: localStorage.getItem(SITENAMEALIAS + '_last_name'),
            //   phone: "000000000000",
            //   merchant_id: localStorage.getItem(SITENAMEALIAS + '_merchant_id'),
            //   two_factor_auth_enabled:1,
            //   google_auth_enabled:1,
            // }
            console.log("working");
            showToast("success", "Google authentication updated successfully");
            this.setState({
              googleAuthModal: false,
              isGoogleAuthChecked: true,
            });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  clearPhnoForEdit = () => {
    this.setState({
      phoneNo: "",
      isPhoneNumberReadonly: false,
      isChangePhnoBtnDisable: true,
    });
  };

  sendOtp = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      countryCode: this.state.countryCode,
      phone: localStorage.getItem(SITENAMEALIAS + "_registredphno"),
      countryCode2: this.state.countryCode2,
      newPhone: this.state.phoneNo,
    };
    changeMobileNo(payload)
      .then(
        function (res) {
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", response.error_msg);
            localStorage.setItem(
              SITENAMEALIAS + "_registredphno",
              this.state.phoneNo
            );
            localStorage.setItem(
              SITENAMEALIAS + "_phoneno",
              this.state.phoneNo
            );
            window.location.reload();
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          showHttpError(err);
        }.bind(this)
      );
  };

  //OTP SEND TO REGISTERED PHONE NUMBER WHILE CHANGEING TO NEW NUMBER
  sendOtpToRegNo = () => {
    this.sendOtpToRegisteredPhno();
    localStorage.setItem("secondStatusCheckForOtpTimer", "true");
    let count = "120";
    localStorage.setItem("cdotpforchangephno", count);
    this.startTimeForChangePhno(count);
  };

  //OTP SEND TO NEW NUMBER FOR CHANGING NUMBER
  sendOtpToNewNo = () => {
    this.sendOtpToNewInsertedPhno();
    localStorage.setItem("secondStatusCheckForNewOtpTimer", "true");
    let count = "120";
    localStorage.setItem("cdotpfornewphno", count);
    this.startTimeForNewPhno(count);
  };

  //VERIFYING OTP SENT TO REGISTRED NUMBER
  verifyChangeNo = (e) => {
    e.preventDefault();
    if (this.registeredPhnoOtpRef.current.value != "") {
      let payload = {
        phone: localStorage.getItem(SITENAMEALIAS + "_registredphno"),
        phone_otp: this.registeredPhnoOtpRef.current.value,
        merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      };
      verifyRegistredPhoneNo(payload)
        .then(
          function (res) {
            let response = res.data[0];
            if (response.error != "0") {
              showToast("error", response.error_msg);
              // alert('failed')
            } else {
              showToast("success", response.success);
              // alert('successs')

              this.sendOtpToNewNo();
              this.setState({
                newPhnoModal: true,
                changePhnoModal: false,
              });
              localStorage.setItem("cdotpforchangephno", "");
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            this.setState({ showLoader: false });
            showHttpError(err);
          }.bind(this)
        );
    }
  };

  submit2faEmailOtp = (e) => {
    e.preventDefault();
    if (this.emailOtpFor2faRef.current.value != "") {
      let payload = {
        merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
        email_otp: this.emailOtpFor2faRef.current.value,
      };
      googleTwoFactorAuth(payload).then(
        function (res) {
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            console.log(response.google_auth_key);
            // this.setState({
            //   googleAuthKey:response.google_auth_key
            // })
            // var auth_key = response.google_auth_key
            var _email = encodeURIComponent(localStorage.getItem(SITENAMEALIAS + "_email"));
            var _issuer = encodeURIComponent(localStorage.getItem(SITENAMEALIAS + "_exchange"));
            var twoFactorAuthKey =
              "otpauth://totp/" +
              _issuer + ":" + _email +
              "?secret=" +
              response.google_auth_key +
              "&issuer=" +
              _issuer;
            this.setState({
              scannerModal: true,
              qrCodeValFor2fa: twoFactorAuthKey,
              isTwoFactorChecked: true,
              googleAuthKey: response.google_auth_key,
            });
            localStorage.setItem("cdotpforemail2fa", "");
          }
        }.bind(this)
      );
    }
  };

  /* Method defination for getting plans details */
  getPlanDetails = (planName) => {
    let plans = this.state.plans;
    let plan = {};
    for (let i = 0; i < plans.length; i++) {
      if (planName == plans[i].volume_name) {
        plan = plans[i];
        break;
      }
    }
    return plan;
  };

  //This function calling an api which performs to update new number
  updateNewNo = (e) => {
    e.preventDefault();
    if (this.newPhnoOtpRef.current.value != "") {
      let payload = {
        newPhone: this.state.phoneNo,
        temp_phone_otp: this.newPhnoOtpRef.current.value,
        phone_otp: this.state.registeredPhnoOtp,
        merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      };
      verifyRegistredPhoneNo(payload)
        .then(
          function (res) {
            let response = res.data[0];
            if (response.error != "0") {
              showToast("error", response.error_msg);
              // alert('failed')
            } else {
              showToast("success", response.error_msg);
              localStorage.setItem(
                SITENAMEALIAS + "_phoneno",
                this.state.phoneNo
              );
              localStorage.setItem("cdotpfornewphno", "");
              window.location.reload();
              // alert('true');
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            this.setState({ showLoader: false });
            showHttpError(err);
          }.bind(this)
        );
    }
  };

  //SEND OTP TO REGISTERED NUMBER
  sendOtpToRegisteredPhno = () => {
    let payload = {
      // phone: localStorage.getItem(SITENAMEALIAS + "_registredphno"),
      // newPhone: "",
      phone: localStorage.getItem(SITENAMEALIAS + "_registredphno"),
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    sendOtpInRegNo(payload)
      .then(
        function (res) {
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", response.error_msg);
            this.setState({
              changePhnoModal: true,
              showTimerForChangPhno: true,
              sendOtpOldNo: true,
              btnProceedToNewNo: false,
            });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  sendOtpToNewInsertedPhno = () => {
    let payload = {
      newPhone: this.state.phoneNo,
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    sendOtpInRegNo(payload)
      .then(
        function (res) {
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", response.error_msg);
            this.setState({
              isTimerShow2: true,
            });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  startTimeForChangePhno = (i) => {
    let count = i;
    this.setState({ otptimertxt: count }, () => {
      let downloadTimer = setInterval(() => {
        if (count <= 1) {
          clearInterval(downloadTimer);
          this.setState({
            secondStatusCheckForMobileOtpTimer: false,
            showTimerForChangPhno: false,
            btnProceedToNewNo: true,
          });
          localStorage.setItem("secondStatusCheckForOtpTimer", "false");
          this.state.sendOtpOldNo = false;
        }
        count -= 1;
        localStorage.setItem("cdotpforchangephno", count);
        this.setState({
          otptimertxt: localStorage.getItem("cdotpforchangephno"),
        });
      }, 1000);
    });
  };

  startTimeForNewPhno = (i) => {
    let count = i;
    this.setState({ timertxt2: count }, () => {
      let downloadTimer = setInterval(() => {
        if (count <= 1) {
          clearInterval(downloadTimer);
          this.setState({
            secondStatusCheckForNewOtpTimer: false,
            isTimerShow2: false,
            btnUpdateToNewNo: true,
          });
          localStorage.setItem("secondStatusCheckForNewOtpTimer", "false");
          this.state.sendOtpInNewnoBtn = false;
        }
        count -= 1;
        localStorage.setItem("cdotpfornewphno", count);
        this.setState({
          timertxt2: localStorage.getItem("cdotpfornewphno"),
        });
      }, 1000);
    });
  };

  startTimerForEmailOtp = (i) => {
    let count = i;
    this.setState({ emailOtpTimerTxt: count }, () => {
      let downloadTimer = setInterval(() => {
        if (count <= 1) {
          clearInterval(downloadTimer);
          this.setState({
            secstatuscheckForEmailOtpTimer: false,
            showEmailOtpTimer: false,
            proceedEmailOtpBtn: true,
            sendEmailOtpFor2faBtn: false,
          });
          localStorage.setItem("secstatuscheckForEmailOtpTimer", "false");
          this.state.sendEmailOtpBtn = false;
        }
        count -= 1;
        localStorage.setItem("cdotpforemail2fa", count);
        this.setState({
          emailOtpTimerTxt: localStorage.getItem("cdotpforemail2fa"),
        });
      }, 1000);
    });
  };

  // ========== EMAIL UPDATE METHODS ==========

  handleEmailUpdateClick = () => {
    let newEmail = this.state.newEmailForUpdate.trim();
    let currentEmail = localStorage.getItem(SITENAMEALIAS + "_email");

    if (newEmail === "") {
      showToast("error", "Please enter new email");
      return;
    }

    let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(newEmail)) {
      showToast("error", "Please enter a valid new email address");
      return;
    }

    if (currentEmail === newEmail) {
      showToast("error", "New email must be different from current email");
      return;
    }

    this.sendEmailUpdateOtp();
  };

  sendEmailUpdateOtp = () => {
    let payload = {
      merchantId: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      oldEmail: localStorage.getItem(SITENAMEALIAS + "_email"),
      newEmail: this.state.newEmailForUpdate.trim(),
    };
    this.setState({ showLoader: true });
    sendEmailOtpForUpdate(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          console.log("ressss", res);
          let response = res.data;
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", response.error_msg);
            this.setState({
              emailUpdateOtpModal: true,
              sendOtpOldEmailBtn: true,
              showOldEmailOtpTimer: true,
            });
            let count = "120";
            localStorage.setItem("cdotpforemailupdate", count);
            this.startTimerForEmailUpdate(count);
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  resendEmailUpdateOtp = () => {
    let payload = {
      merchantId: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      oldEmail: localStorage.getItem(SITENAMEALIAS + "_email"),
      newEmail: this.state.newEmailForUpdate.trim(),
    };
    sendEmailOtpForUpdate(payload)
      .then(
        function (res) {
          let response = res.data;
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", response.error_msg);
            this.setState({
              sendOtpOldEmailBtn: true,
              showOldEmailOtpTimer: true,
            });
            let count = "120";
            localStorage.setItem("cdotpforemailupdate", count);
            this.startTimerForEmailUpdate(count);
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  submitEmailUpdateOtp = (e) => {
    e.preventDefault();
    let oldOtp = this.oldEmailOtpRef.current.value;
    let newOtp = this.newEmailOtpRef.current.value;

    if (oldOtp === "") {
      showToast("error", "Please enter OTP from current email");
      return;
    }
    if (newOtp === "") {
      showToast("error", "Please enter OTP from new email");
      return;
    }

    let payload = {
      merchantId: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      oldEmail: localStorage.getItem(SITENAMEALIAS + "_email"),
      newEmail: this.state.newEmailForUpdate.trim(),
      oldEmailOtp: oldOtp,
      newEmailOtp: newOtp,
    };
    this.setState({ showLoader: true });
    updateMerchantEmail(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data;
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast(
              "success",
              response.error_msg || "Email updated successfully"
            );
            localStorage.setItem(
              SITENAMEALIAS + "_email",
              this.state.newEmailForUpdate.trim()
            );
            localStorage.setItem("cdotpforemailupdate", "");
            this.setState({
              emailUpdateOtpModal: false,
              currentEmailForUpdate: "",
              newEmailForUpdate: "",
            });
            window.location.reload();
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  startTimerForEmailUpdate = (i) => {
    let count = i;
    this.setState({ oldEmailOtpTimerTxt: count }, () => {
      let downloadTimer = setInterval(() => {
        if (count <= 1) {
          clearInterval(downloadTimer);
          this.setState({
            showOldEmailOtpTimer: false,
            sendOtpOldEmailBtn: false,
          });
          localStorage.setItem("cdotpforemailupdate", "");
        }
        count -= 1;
        localStorage.setItem("cdotpforemailupdate", count);
        this.setState({
          oldEmailOtpTimerTxt: localStorage.getItem("cdotpforemailupdate"),
        });
      }, 1000);
    });
  };

  // ========== END EMAIL UPDATE METHODS ==========

  phoneSmsAuth = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    if (this.state.isPhoneAuthChecked == false) {
      this.setState({
        isPhoneAuthChecked: true,
      });
      payload["phone_auth_enabled"] = "1";

      phoneAuthEnable(payload)
        .then(
          function (res) {
            let response = res.data[0];
            if (response.error != "0") {
              showToast("error", response.error_msg);
            } else {
              this.handleLogout();
              showToast("success", response.error_msg);
              localStorage.setItem("userSmsAuth", "1");
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            this.setState({ showLoader: false });
            showHttpError(err);
          }.bind(this)
        );
    } else {
      if (
        localStorage.getItem(SITENAMEALIAS + "_is_google_auth_enabled") == "0"
      ) {
        showToast(
          "error",
          "Please turn on google authentication from settings."
        );
      } else {
        this.setState({
          showVerifyOtpModalWhilePhoneAuthDisable: true,
        });
      }
    }
  };

  googleAuthVerify = (e) => {
    e.preventDefault();
    if (this.googleAuthOtpRef.current.value != "") {
      let payload = {
        phone_auth_enabled: 0,
        otp: this.googleAuthOtpRef.current.value,
        merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      };

      phoneAuthDisable(payload)
        .then(
          function (res) {
            let response = res.data[0];

            if (response.error != "0") {
              showToast("error", response.error_msg);
            } else {
              this.setState({
                isPhoneAuthChecked: false,
              });
              this.handleLogout();
              showToast("success", response.error_msg);
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            this.setState({ showLoader: false });
            showHttpError(err);
          }.bind(this)
        );
    }
  };

  checkTwoFactorOnOff = () => {
    //First checking user's google auth is enable or disable
    if (
      localStorage.getItem(SITENAMEALIAS + "_is_google_auth_enabled") == "1"
    ) {
      this.setState({
        twoFactorDisableModal: true, //ON
      });
      this.sendEmailFor2fa();
    } else {
      //Check for user previously enabled google auth
      if (localStorage.getItem("exit_2fa_key") == "0") {
        this.setState({
          twoFaSendEmailOtpModal: true, //email otp modal for first time user will open
        });
        this.sendEmailFor2fa();
      } else {
        if (
          localStorage.getItem(SITENAMEALIAS + "_is_google_auth_enabled") == "1"
        ) {
          this.setState({
            twoFactorDisableModal: true, // OFF
          });
          this.sendEmailFor2fa();
        } else {
          this.setState({
            twoFactorDisableModal: true, //ON
          });
          this.sendEmailFor2fa();
        }
      }
    }
    // if (localStorage.getItem("exit_2fa_key") == "0") {
    //   this.setState({
    //     twoFaSendEmailOtpModal: true, //email otp modal for first time user will open
    //   });
    // } else {
    //   if (
    //     localStorage.getItem(SITENAMEALIAS + "_is_google_auth_enabled") == "1"
    //   ) {
    //     this.setState({
    //       twoFactorDisableModal: true, // OFF
    //     });
    //   } else {
    //     this.setState({
    //       twoFactorDisableModal: true, //ON
    //     });
    //   }
    // }
  };

  saveTwoFactorSettingOff = (e) => {
    e.preventDefault();
    if (
      this.emailOtpForTwoFaOff.current.value != "" &&
      this.gaCodeFor2faOff.current.value != ""
    ) {
      if (
        localStorage.getItem(SITENAMEALIAS + "_is_google_auth_enabled") == "0"
      ) {
        let payload = {
          // google_auth_enabled: "0",
          merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
          email_otp: this.emailOtpForTwoFaOff.current.value,
          // google_factor_otp: this.gaCodeFor2faOff.current.value,
        };
        googleTwoFactorAuth(payload).then(
          function (res) {
            let response = res.data[0];
            if (response.error != "0") {
              showToast("error", response.error_msg);
            } else {
              var _email = encodeURIComponent(localStorage.getItem(SITENAMEALIAS + "_email"));
              var _issuer = encodeURIComponent(localStorage.getItem(SITENAMEALIAS + "_exchange"));
              var twoFactorAuthKey =
                "otpauth://totp/" +
                _issuer + ":" + _email +
                "?secret=" +
                response.google_auth_key +
                "&issuer=" +
                _issuer;
              this.setState({
                scannerModal: true,
                qrCodeValFor2fa: twoFactorAuthKey,
                googleAuthKey: response.google_auth_key,
              });
              localStorage.setItem("cdotpforemail2fa", "");
            }
          }.bind(this)
        );
      }

      if (
        localStorage.getItem(SITENAMEALIAS + "_is_google_auth_enabled") == "1"
      ) {
        let payload = {
          merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
          google_auth_enabled: "0",
          google_factor_otp: this.gaCodeFor2faOff.current.value,
          email_otp: this.emailOtpForTwoFaOff.current.value,
        };
        SaveTwoFactorSettings(payload).then(
          function (res) {
            let response = res.data[0];
            if (response.error != "0") {
              showToast("error", response.error_msg);
            } else {
              showToast("success", response.error_msg);
              this.handleLogout();
            }
          }.bind(this)
        );
      }

      // SaveTwoFactorSettings(payload).then(
      //   function (res) {
      //     let response = res.data;
      //     let errorObj = response[response.length - 1];
      //     if (errorObj.error != "0") {
      //       showToast("error", errorObj.error_msg);
      //     } else {
      //       if (
      //         localStorage.getItem(SITENAMEALIAS + "_is_google_auth_enabled") ==
      //           "0" &&
      //         this.emailOtpForTwoFaOff.current.value != ""
      //       ) {
      //         let payload = {
      //           merchant_id: localStorage.getItem(
      //             SITENAMEALIAS + "_merchant_id"
      //           ),
      //           email_otp: this.emailOtpForTwoFaOff.current.value,
      //         };
      //         googleTwoFactorAuth(payload).then(
      //           function (res) {
      //             let response = res.data[0];
      //             if (response.error != "0") {
      //               showToast("error", response.error_msg);
      //             } else {
      //               console.log(response.google_auth_key);
      //               // var auth_key = response.google_auth_key
      //               var twoFactorAuthKey =
      //                 "otpauth://totp/" +
      //                 localStorage.getItem(SITENAMEALIAS + "_email") +
      //                 "?secret=" +
      //                 response.google_auth_key +
      //                 "&issuer=BillBitcoin";
      //               this.setState({
      //                 scannerModal: true,
      //                 qrCodeValFor2fa: twoFactorAuthKey,
      //               });
      //             }
      //           }.bind(this)
      //         );

      //         this.emailOtpForTwoFaOff.current.value = "";
      //         this.gaCodeFor2faOff.current.value = "";
      //       } else {
      //         this.handleLogout();
      //       }

      //       // showToast("success",)
      //     }
      //   }.bind(this)
      // );
    }
  };

  sendEmailFor2fa = () => {
    let payload = {
      email: localStorage.getItem(SITENAMEALIAS + "_email"),
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    sendOtpForTwoFa(payload)
      .then(
        function (res) {
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", "Otp send to your given email");
            this.setState({
              showEmailOtpTimer: !this.state.showEmailOtpTimer,
              proceedEmailOtpBtn: false,
              sendEmailOtpFor2faBtn: true,
              sendEmailOtpBtn: true,
            });
            localStorage.setItem("secstatuscheckForEmailOtpTimer", "true");
            let count = "120";
            localStorage.setItem("cdotpforemail2fa", count);
            this.startTimerForEmailOtp(count);
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          //console.log('3', err)
          showHttpError(err);
        }.bind(this)
      );
  };

  showHiddenNumber = () => {
    let phone = localStorage.getItem(SITENAMEALIAS + "_phoneno");
    this.state.result = "";
    if (phone != undefined && phone != null) {
      for (let i = 0; i < phone.length; i++) {
        if (i > 3 && i <= 8) {
          this.state.result += "*";
        } else {
          this.state.result += phone[i];
        }
      }
      return this.state.result;
    }
  };

  /* Method defination for rendering asset lists */

  handleRenderAssets = () => {
    console.log("Rendering Asset");
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });

    FetchUsdBtcLedgerAmount(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          console.log(response);
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            if (response != undefined && response != null) {
              let coinBalance = response.coin_balance;
              // let assets = this.state.assets;
              let arr = [];
              if (coinBalance != undefined) {
                for (let i = 0; i < coinBalance.length; i++) {
                  if (coinBalance[i].currency_code != "USD") {
                    let obj = {
                      assetName: coinBalance[i].currency_name,
                      coinBalance: coinBalance[i].balance,
                      assetCode: coinBalance[i].currency_code,
                      assetId: coinBalance[i].currency_id,
                      assetImage: coinBalance[i].logo,
                      network: coinBalance[i].network,
                      isBrokerCurrency: coinBalance[i].is_broker_currency,
                    };
                    arr.push(obj);
                  }
                }
              } else {
              }

              this.setState(
                {
                  assets: arr,
                },
                () => {
                  console.log(this.state.assets);
                  localStorage.setItem(
                    SITENAMEALIAS + "_assets",
                    JSON.stringify(this.state.assets)
                  );
                }
              );
            }
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          //console.log('4', err)
          showHttpError(err);
        }.bind(this)
      );
  };

  allApiTypeKey = () => {
    axios
      .get(`${WEBSERVICE}/apiKey/allApiType`, {
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "bearer " + getAuthToken(),
          UUID: getAuthUuid(),
        },
      })
      .then((response) => {
        let apitype = response.data.apiTypeList;
        console.log("all apisss type before", apitype);

        console.log("all apisss type after", apitype);

        this.setState({ apitype });
      })
      .catch((error) => {
        console.error("Error fetching API types:", error);
      });
  };

  getApiKeyList = () => {
    const merchant_id = localStorage.getItem(SITENAMEALIAS + "_merchant_id");

    const merchant_uuid = localStorage.getItem(
      SITENAMEALIAS + "_merchant_uuid"
    );

    axios
      .post(
        `${WEBSERVICE}/apiKey/getUserWiseApiKeyDetails`,
        {
          merchant_id,
          merchant_uuid,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "bearer " + getAuthToken(),
            UUID: getAuthUuid(),
          },
        }
      )
      .then((response) => {
        this.setState({ apikeylist: response.data.api_keys || [] });
      })
      .catch((error) => {
        console.error("Error fetching API keys:", error);
      });
  };

  createAPIkey = () => {
    // e.preventDefault();

    const merchant_id = localStorage.getItem(SITENAMEALIAS + "_merchant_id");

    const merchant_uuid = localStorage.getItem(
      SITENAMEALIAS + "_merchant_uuid"
    );
    const keyName = this.state.newAPIKeyName;
    const securityCode = this.gaCodeFor2faOff.current.value;
    const emailOtp = this.emailOtpForTwoFaOff.current.value;

    axios
      .post(
        `${WEBSERVICE}/apiKey/generateKeys`,
        {
          merchant_id,
          merchant_uuid,
          keyName,
          securityCode,
          emailOtp,
          ...this.state.newApiPermissions,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "bearer " + getAuthToken(),
            UUID: getAuthUuid(),
          },
        }
      )

      .then((response) => {
        if (response.data.error?.error_data !== 0) {
          // this.data.alert(response.error.error_msg, "danger");
          showToast("error", response.data.error?.error_message);
        } else {
          showToast("success", response.data.error?.error_message);

          this.setState({ newApiKeyGen: response.data.apiKey });
          this.setState({ newApiSecretKeyGen: response.data.secretKey });
          this.setState({
            twoFactorAPIKeyModal: false,
          });
          // console.log('API Key created successfully:', response.data);
          // showToast('success', 'API Key created successfully')
          this.getApiKeyList(); // Refresh list
        }
      })
      .catch((error) => {
        console.error("Error fetching API keys:", error);
      });
  };

  componentDidMount() {
    this.setState({
      permission: currentPageAccess(),
    });
    this.handleRenderAssets();
    this.renderUserSettingsData();
    this.showHiddenNumber();
    this.renderAllIndustry();
    this.allApiTypeKey();
    this.getApiKeyList();

    if (
      localStorage.getItem(SITENAMEALIAS + "_need_tolerance_setting") == "true"
    ) {
      this.handleSettingsToggle("app");
      this.setState(
        {
          showAutomaticExceptionHandlingModal: true,
          selectedCurrencyIdForAutomaticExceptionHandling: localStorage.getItem(
            SITENAMEALIAS + "_need_tolerance_setting_for_currency"
          ),
        },
        () => {
          this.renderSettingsForAutomaticExceptionHandling(
            this.state.selectedCurrencyIdForAutomaticExceptionHandling
          );
          setTimeout(() => {
            localStorage.removeItem(SITENAMEALIAS + "_need_tolerance_setting");
            localStorage.removeItem(
              SITENAMEALIAS + "_need_tolerance_setting_for_currency"
            );
          }, 2000);
        }
      );
    }

    //this timer is used for registered mobile otp modal
    if (localStorage.getItem("secondStatusCheckForNewOtpTimer") == "true") {
      this.startTimeForNewPhno(localStorage.getItem("cdotpfornewphno"));
      this.setState({
        secondStatusCheckForNewOtpTimer: true,
        sendOtpInNewnoBtn: true,
        isTimerShow2: true,
        timertxt2: localStorage.getItem("cdotpfornewphno"),
      });
    } else {
      this.setState({
        secondStatusCheckForNewOtpTimer: false,
      });
    }
    //this timer is used for new mobile otp modal
    if (localStorage.getItem("secondStatusCheckForOtpTimer") == "true") {
      this.startTimeForChangePhno(localStorage.getItem("cdotpforchangephno"));
      this.setState({
        secondStatusCheckForOtpTimer: true,
        sendOtpInRegnoBtn: true,
        isTimerShow: true,
        timertxt: localStorage.getItem("cdotpforchangephno"),
      });
    } else {
      this.setState({
        secondStatusCheckForOtpTimer: false,
      });
    }

    //this timer is used for change password otp
    if (localStorage.getItem("secstatuscheckForChangePswdTimer") == "true") {
      this.startTimerForChangePswd(
        localStorage.getItem("cdotpforchangepassword")
      );
      this.setState({
        showChangePswdOtpTimer: true,
        sendChangePswdOtpBtn: true,
        changePswdConfirmBtnDisabled: true,
        changePswdOtpTimerTxt: localStorage.getItem("cdotpforchangepassword"),
        showChangePasswordAuthModal: true,
      });
    }

    //this timer is used for send email otp while user enable 2FA
    if (localStorage.getItem("secstatuscheckForEmailOtpTimer") == "true") {
      this.startTimerForEmailOtp(localStorage.getItem("cdotpforemail2fa"));
      this.setState({
        secstatuscheckForEmailOtpTimer: true,
        sendEmailOtpFor2faBtn: true,
        sendEmailOtpBtn: true,
        showEmailOtpTimer: true,
        proceedEmailOtpBtn: false,
        emailOtpTimerTxt: localStorage.getItem("cdotpforemail2fa"),
      });
    } else {
      this.setState({
        secstatuscheckForEmailOtpTimer: false,
        sendEmailOtpBtn: false,
        proceedEmailOtpBtn: true,
      });
    }
  }

  handleAPICreate = () => {
    if (this.state.newAPIKeyName == "" || this.state.newAPIKeyName == null) {
      showToast("error", "Please add a API key name");
    } else {
      if (
        localStorage.getItem(SITENAMEALIAS + "_is_google_auth_enabled") === "1"
      ) {
        this.setState({
          twoFactorAPIKeyModalStatus: "Create",
        });

        this.setState({
          twoFactorAPIKeyModal: true,
        });
        this.sendEmailFor2fa();
      } else {
        showToast("error", "Please turn on Google Authentication in Settings.");
      }
    }
  };

  handleAPIEdit = () => {
    const selected = this.state.selectedApiKey;

    const permissionKeys = [
      "isDashboard",
      "isProductsPrice",
      "isCreatePayment",
      "isTransactions",
      "isSettlements",
      "isAnalytics",
      "isTeam",
      "isPaymentSetup",
      "isCheckoutTemplates",
      "isLimits",
      "isPaymentTolerance",
    ];

    const hasWrite = permissionKeys.some((k) => selected?.[k] === 2);

    if (hasWrite) {
      if (this.state.ipRestrictStatus !== 1) {
        showToast(
          "error",
          "You must restrict access to trusted IPs when any permission has Write access."
        );
        return;
      }
      const validIps = this.state.ipListTemp.filter((ip) => ip.trim() !== "");
      if (validIps.length === 0) {
        showToast(
          "error",
          "At least one trusted IP address is required for Write permissions."
        );
        return;
      }
    }

    if (
      localStorage.getItem(SITENAMEALIAS + "_is_google_auth_enabled") === "1"
    ) {
      this.setState({
        twoFactorAPIKeyModalStatus: "Edit",
        twoFactorAPIKeyModal: true,
      });
      this.sendEmailFor2fa();
    } else {
      showToast("error", "Please turn on Google Authentication in Settings.");
    }
  };

  handleDeleteApiKey = (data) => {
    this.state.deletePayload = {
      id: data.id,
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      merchant_uuid: getAuthUuid(),
      keyName: data.keyName,
      action: "DELETE",
      ipAddress: data.ipAddress,
      isRead: data.isRead,
      isDashboard: data.isDashboard,
      isPayments: data.isPayments,
      isPaymentButton: data.isPaymentButton,
      isRecurringPayment: data.isRecurringPayment,
      isEmailBilling: data.isEmailBilling,
      isHostedCatalog: data.isHostedCatalog,
      isInsights: data.isInsights,
      // "securityCode":"095137",
      // "emailOtp":1031619
    };

    if (
      localStorage.getItem(SITENAMEALIAS + "_is_google_auth_enabled") === "1"
    ) {
      this.setState({
        twoFactorAPIKeyModalStatus: "Delete",
      });

      this.setState({
        twoFactorAPIKeyModal: true,
      });
      this.sendEmailFor2fa();
    } else {
      showToast("error", "Please turn on Google Authentication in Settings.");
    }
  };

  handleDeleteAll = () => {
    if (
      localStorage.getItem(SITENAMEALIAS + "_is_google_auth_enabled") === "1"
    ) {
      this.setState({
        twoFactorAPIKeyModalStatus: "DeleteAll",
      });

      this.setState({
        twoFactorAPIKeyModal: true,
      });
      this.sendEmailFor2fa();
    } else {
      showToast("error", "Please turn on Google Authentication in Settings.");
    }
  };

  updateApiKey = async () => {
    // e.preventDefault()
    const selected = this.state.selectedApiKey;

    const authObj = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      merchant_uuid: getAuthUuid(),
      id: selected.id,
      keyName: selected.keyName,
      apiKey: selected.apiKey,
      secretKey: selected.secretKey,
      securityCode: this.gaCodeFor2faOff.current.value,
      emailOtp: this.emailOtpForTwoFaOff.current.value,
      action: "UPDATE",
      // 0=no access, 1=Read, 2=Write — sent as-is from state
      isDashboard: selected.isDashboard ?? 0,
      isProductsPrice: selected.isProductsPrice ?? 0,
      isCreatePayment: selected.isCreatePayment ?? 0,
      isTransactions: selected.isTransactions ?? 0,
      isSettlements: selected.isSettlements ?? 0,
      isAnalytics: selected.isAnalytics ?? 0,
      isTeam: selected.isTeam ?? 0,
      isPaymentSetup: selected.isPaymentSetup ?? 0,
      isCheckoutTemplates: selected.isCheckoutTemplates ?? 0,
      isLimits: selected.isLimits ?? 0,
      isPaymentTolerance: selected.isPaymentTolerance ?? 0,
      ipAddress: this.state.ipListTemp.join(","),
    };

    try {
      const response = await fetch(WEBSERVICE + "/apiKey/updateKeys", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "bearer " + getAuthToken(),
          UUID: getAuthUuid(),
        },
        body: JSON.stringify(authObj),
      });

      const result = await response.json();

      console.log("result", result);
      this.setState({ showEditApiModal: false }); // Close modal
      this.setState({
        twoFactorAPIKeyModal: false,
      });

      if (result.error?.error_data !== 0) {
        // this.data.alert(result.error.error_msg, "danger");
        showToast("error", result.error?.error_message);
      } else {
        showToast("success", result.error?.error_message);

        // this.data.alert("Updated successfully", "success");
        this.getApiKeyList(); // Refresh list
      }
    } catch (error) {
      console.error("API update failed:", error);
      // this.data.alert("Something went wrong. Please try again.", "danger");
    }
  };

  deleteApiKeyById = async (e) => {
    this.state.deletePayload.securityCode = this.gaCodeFor2faOff.current.value;
    this.state.deletePayload.emailOtp = this.emailOtpForTwoFaOff.current.value;

    try {
      const response = await fetch(WEBSERVICE + "/apiKey/updateKeys", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "bearer " + getAuthToken(),
          UUID: getAuthUuid(),
        },
        body: JSON.stringify(this.state.deletePayload),
      });

      const result = await response.json();

      if (result.error?.error_data !== 0) {
        // this.data.alert(result.error.error_msg, "danger");
        showToast("error", result.error?.error_message);
      } else {
        showToast("success", result.error?.error_message);

        // this.data.alert("Updated successfully", "success");
        this.setState({ showEditApiModal: false }); // Close modal
        this.setState({
          twoFactorAPIKeyModal: false,
        });
        this.getApiKeyList(); // Refresh list
      }
    } catch (error) {
      console.error("API update failed:", error);
      // this.data.alert("Something went wrong. Please try again.", "danger");
    }
  };

  deleteApiKey = async (e) => {
    const merchant_id = localStorage.getItem(SITENAMEALIAS + "_merchant_id");

    const merchant_uuid = localStorage.getItem(
      SITENAMEALIAS + "_merchant_uuid"
    );

    axios
      .post(
        `${WEBSERVICE}/apiKey/deleteAllApiKeys`,
        {
          merchant_id,
          merchant_uuid,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "bearer " + getAuthToken(),
            UUID: getAuthUuid(),
          },
        }
      )
      .then((res) => {
        let response = res.data.error;
        this.setState({ showEditApiModal: false }); // Close modal

        if (response.error_data != 0) {
          showToast("error", response.error_message);
        } else {
          showToast("success", "API keys deleted successfuly");
          // this.handleLogout();
        }
      })
      .catch((error) => {
        console.error("Error fetching API keys:", error);
      });
  };
  handleDeleteAllAPIs = async () => {
    const confirmed = window.confirm(
      "Are you sure you want to delete all APIs?"
    );
    if (confirmed) {
      this.handleDeleteAll();
    }
  };

  handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    showToast("success", "Copied");
  };

  render() {
    const { apiKey, apiSecret, permissions } = this.state;

    const settingsStyles = {
      pageWrapper: {
        padding: "40px 24px 60px",
      },
      pageHeader: {
        marginBottom: "28px",
      },
      pageTitle: {
        fontSize: "24px",
        fontWeight: "700",
        color: "var(--text-color)",
        margin: 0,
      },
      pageSubtitle: {
        fontSize: "13px",
        opacity: 0.5,
        margin: "4px 0 0",
      },
      sectionCard: {
        background: "var(--body-color-less)",
        borderRadius: "16px",
        border: "1px solid var(--body-color-less2)",
        padding: "28px 28px 24px",
        marginBottom: "24px",
        boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
        transition: "all 0.3s ease",
      },
      sectionHeader: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        marginBottom: "20px",
        paddingBottom: "14px",
        borderBottom: "2px solid var(--body-color-less2)",
      },
      sectionIcon: {
        width: "40px",
        height: "40px",
        borderRadius: "10px",
        background:
          "linear-gradient(135deg, color-mix(in srgb, var(--btn-color), transparent 85%), color-mix(in srgb, var(--btn-color), transparent 92%))",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "18px",
        color: "var(--btn-color)",
        flexShrink: 0,
      },
      sectionTitle: {
        fontSize: "17px",
        fontWeight: "700",
        margin: 0,
        color: "var(--text-color)",
      },
      sectionDesc: {
        fontSize: "12px",
        opacity: 0.6,
        margin: 0,
      },
      formLabel: {
        fontSize: "13px",
        fontWeight: "600",
        marginBottom: "6px",
        color: "var(--text-color)",
        display: "block",
      },
      formInput: {
        width: "100%",
        padding: "10px 14px",
        borderRadius: "8px",
        border: "1px solid var(--body-color-less2)",
        background: "var(--body-color)",
        color: "var(--text-color)",
        fontSize: "13px",
        transition: "border-color 0.2s ease",
        outline: "none",
      },
      btnPrimary: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "10px 24px",
        background: "var(--btn-color)",
        color: "#fff",
        border: "none",
        borderRadius: "8px",
        fontSize: "13px",
        fontWeight: "600",
        cursor: "pointer",
        textDecoration: "none",
        transition: "all 0.2s ease",
      },
      btnOutline: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "10px 24px",
        background: "transparent",
        color: "var(--btn-color)",
        border: "2px solid var(--btn-color)",
        borderRadius: "8px",
        fontSize: "13px",
        fontWeight: "600",
        cursor: "pointer",
        textDecoration: "none",
        transition: "all 0.2s ease",
      },
      btnDanger: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "10px 24px",
        background: "#ef4444",
        color: "#fff",
        border: "none",
        borderRadius: "8px",
        fontSize: "13px",
        fontWeight: "600",
        cursor: "pointer",
        transition: "all 0.2s ease",
      },
      btnDisabled: {
        display: "inline-flex",
        alignItems: "center",
        padding: "10px 24px",
        background: "var(--body-color-less2)",
        color: "var(--text-color)",
        border: "none",
        borderRadius: "8px",
        fontSize: "13px",
        fontWeight: "600",
        cursor: "not-allowed",
        opacity: 0.5,
      },
      toggleRow: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "12px 16px",
        background: "var(--body-color)",
        borderRadius: "10px",
        border: "1px solid var(--body-color-less2)",
      },
      toggleLabel: {
        fontSize: "14px",
        fontWeight: "500",
        color: "var(--text-color)",
      },
      toggleSwitch: {
        position: "relative",
        width: "44px",
        height: "24px",
        cursor: "pointer",
      },
      fieldRow: {
        display: "flex",
        gap: "16px",
        flexWrap: "wrap",
      },
      fieldGroup: {
        flex: "1 1 200px",
        marginBottom: "16px",
      },
      dangerZone: {
        background:
          "linear-gradient(135deg, rgba(239,68,68,0.06), rgba(239,68,68,0.02))",
        border: "1px solid rgba(239,68,68,0.2)",
        borderRadius: "16px",
        padding: "28px 28px 24px",
        marginBottom: "24px",
      },
      dangerHeader: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        marginBottom: "16px",
        paddingBottom: "14px",
        borderBottom: "2px solid rgba(239,68,68,0.15)",
      },
      dangerIcon: {
        width: "40px",
        height: "40px",
        borderRadius: "10px",
        background: "rgba(239,68,68,0.1)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "18px",
        color: "#ef4444",
        flexShrink: 0,
      },
    };

    return (
      <Fragment>
        <style>{`
          @media (max-width: 576px) {
            .us-page-wrapper { padding: 20px 14px 40px !important; }
            .us-card { padding: 18px 16px 16px !important; }
            .us-section-header { flex-direction: column !important; align-items: flex-start !important; gap: 10px !important; }
            .us-section-icon { width: 34px !important; height: 34px !important; font-size: 15px !important; }
            .us-section-title { font-size: 15px !important; }
            .us-section-desc { font-size: 11px !important; }
            .us-field-row { flex-direction: column !important; gap: 0 !important; }
            .us-field-group { flex: 1 1 100% !important; }
            .us-toggle-row { flex-direction: column !important; align-items: flex-start !important; gap: 10px !important; padding: 12px 14px !important; }
            .us-phone-row { flex-direction: column !important; align-items: stretch !important; gap: 10px !important; }
            .us-phone-btns { justify-content: flex-start !important; }
            .us-api-header { flex-direction: column !important; align-items: flex-start !important; gap: 10px !important; }
            .us-api-table-wrap { overflow-x: auto !important; overflow-y: visible !important; -webkit-overflow-scrolling: touch; display: block !important; scrollbar-width: none; -ms-overflow-style: none; }
            .us-api-table-wrap::-webkit-scrollbar { display: none; }
            .us-api-table-wrap table { min-width: 750px !important; white-space: nowrap; }
            .us-api-key-row { flex-direction: column !important; }
            .us-api-key-row input { width: 100% !important; }
            .us-danger-zone { padding: 18px 16px 16px !important; }
            .us-danger-header { flex-direction: column !important; align-items: flex-start !important; gap: 10px !important; }
            .us-btn { padding: 8px 16px !important; font-size: 12px !important; }
          }
        `}</style>
        <div className="container-scroller">
          <Sidebar />
          <Header />
          <div className="main-panel">
            {this.state.showUserSettings && (
              <div
                className="us-page-wrapper"
                style={settingsStyles.pageWrapper}
              >
                <PageHeader
                  icon="mdi-account-settings"
                  title="User Settings"
                  subtitle="Manage your account preferences, security, and API access"
                />

                {/* BASIC SETTINGS CARD */}
                <div className="us-card" style={settingsStyles.sectionCard}>
                  <div
                    className="us-section-header"
                    style={settingsStyles.sectionHeader}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      <div
                        className="us-section-icon"
                        style={settingsStyles.sectionIcon}
                      >
                        <i className="fas fa-user"></i>
                      </div>
                      <div>
                        <h3
                          className="us-section-title"
                          style={settingsStyles.sectionTitle}
                        >
                          Profile Information
                        </h3>
                        <p
                          className="us-section-desc"
                          style={settingsStyles.sectionDesc}
                        >
                          Update your personal details
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="us-field-row" style={settingsStyles.fieldRow}>
                    <div
                      className="us-field-group"
                      style={settingsStyles.fieldGroup}
                    >
                      <label style={settingsStyles.formLabel}>First Name</label>
                      <input
                        style={settingsStyles.formInput}
                        onChange={(e) => {
                          let reg = /^[A-Za-z]+$/;
                          if (e.target.value.match(reg)) {
                            this.setState({ firstName: e.target.value });
                          } else {
                            e.target.value = e.target.value.slice(0, -1);
                            this.setState({ firstName: e.target.value });
                          }
                        }}
                        placeholder="Enter First Name"
                        defaultValue={this.state.firstName}
                      />
                    </div>
                    <div
                      className="us-field-group"
                      style={settingsStyles.fieldGroup}
                    >
                      <label style={settingsStyles.formLabel}>Last Name</label>
                      <input
                        style={settingsStyles.formInput}
                        onChange={(e) => {
                          let reg = /^[A-Za-z]+$/;
                          if (e.target.value.match(reg)) {
                            this.setState({ lastName: e.target.value });
                          } else {
                            e.target.value = e.target.value.slice(0, -1);
                            this.setState({ lastName: e.target.value });
                          }
                        }}
                        placeholder="Enter Last Name"
                        defaultValue={this.state.lastName}
                      />
                    </div>
                  </div>
                  <div style={{ marginTop: "8px" }}>
                    {this.state.permission == "WRITE" ? (
                      <button
                        type="button"
                        style={settingsStyles.btnPrimary}
                        onClick={this.handleSaveBasicUserSettings}
                      >
                        <i className="fas fa-save"></i> Save Changes
                      </button>
                    ) : (
                      <button
                        type="button"
                        style={settingsStyles.btnDisabled}
                        onClick={() => {
                          showToast(
                            "error",
                            "You need write access to perform this operation"
                          );
                        }}
                        disabled
                      >
                        Save Changes
                      </button>
                    )}
                  </div>
                  <PaybitoCaptcha
                    ref={this.basicSettingRecaptchaRef}
                    sitekey={CAPTCHASITEKEY}
                  />
                </div>

                {/* EMAIL UPDATE CARD */}
                <div className="us-card" style={settingsStyles.sectionCard}>
                  <div
                    className="us-section-header"
                    style={settingsStyles.sectionHeader}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      <div
                        className="us-section-icon"
                        style={settingsStyles.sectionIcon}
                      >
                        <i className="fas fa-envelope"></i>
                      </div>
                      <div>
                        <h3
                          className="us-section-title"
                          style={settingsStyles.sectionTitle}
                        >
                          Update Email Address
                        </h3>
                        <p
                          className="us-section-desc"
                          style={settingsStyles.sectionDesc}
                        >
                          Change the email associated with your account
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="us-field-row" style={settingsStyles.fieldRow}>
                    <div
                      className="us-field-group"
                      style={settingsStyles.fieldGroup}
                    >
                      <label style={settingsStyles.formLabel}>
                        Current Email
                      </label>
                      <input
                        type="email"
                        style={{
                          ...settingsStyles.formInput,
                          opacity: 0.7,
                          cursor: "not-allowed",
                        }}
                        placeholder="Enter current email"
                        value={localStorage.getItem(SITENAMEALIAS + "_email")}
                        readOnly
                      />
                    </div>
                    <div
                      className="us-field-group"
                      style={settingsStyles.fieldGroup}
                    >
                      <label style={settingsStyles.formLabel}>New Email</label>
                      <input
                        type="email"
                        style={settingsStyles.formInput}
                        placeholder="Enter new email"
                        value={this.state.newEmailForUpdate}
                        onChange={(e) => {
                          this.setState({
                            newEmailForUpdate: e.target.value,
                            newEmailError: "",
                          });
                        }}
                      />
                      {this.state.newEmailError && (
                        <small
                          style={{
                            color: "#ef4444",
                            fontSize: "12px",
                            marginTop: "4px",
                            display: "block",
                          }}
                        >
                          {this.state.newEmailError}
                        </small>
                      )}
                    </div>
                  </div>
                  <div style={{ marginTop: "8px" }}>
                    <button
                      type="button"
                      style={
                        !this.state.newEmailForUpdate
                          ? settingsStyles.btnDisabled
                          : settingsStyles.btnPrimary
                      }
                      disabled={!this.state.newEmailForUpdate}
                      onClick={this.handleEmailUpdateClick}
                    >
                      <i
                        className="fas fa-paper-plane"
                        style={{ paddingRight: "5px" }}
                      ></i>{" "}
                      Update Email
                    </button>
                  </div>
                </div>

                {/* SECURITY SECTION - 2FA + Phone Auth */}
                <div className="us-card" style={settingsStyles.sectionCard}>
                  <div
                    className="us-section-header"
                    style={settingsStyles.sectionHeader}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      <div
                        className="us-section-icon"
                        style={settingsStyles.sectionIcon}
                      >
                        <i className="fas fa-shield-halved"></i>
                      </div>
                      <div>
                        <h3
                          className="us-section-title"
                          style={settingsStyles.sectionTitle}
                        >
                          Security & Authentication
                        </h3>
                        <p
                          className="us-section-desc"
                          style={settingsStyles.sectionDesc}
                        >
                          Protect your account with additional security layers
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* 2FA Toggle */}
                  <div
                    className="us-toggle-row"
                    style={{
                      ...settingsStyles.toggleRow,
                      marginBottom: "12px",
                    }}
                  >
                    <div>
                      <span style={settingsStyles.toggleLabel}>
                        <i
                          className="fas fa-qrcode"
                          style={{
                            marginRight: "8px",
                            color: "var(--btn-color)",
                          }}
                        ></i>
                        Two-Factor Authentication (2FA) at Login
                      </span>
                      <p
                        style={{
                          fontSize: "12px",
                          opacity: 0.5,
                          margin: "4px 0 0 26px",
                        }}
                      >
                        Require a verification code when signing in
                      </p>
                    </div>
                    <label
                      style={{
                        position: "relative",
                        display: "inline-block",
                        width: "48px",
                        height: "26px",
                        marginBottom: 0,
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={this.state.isTwoFactorChecked}
                        onClick={this.checkTwoFactorOnOff}
                        style={{ opacity: 0, width: 0, height: 0 }}
                      />
                      <span
                        style={{
                          position: "absolute",
                          cursor: "pointer",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          backgroundColor: this.state.isTwoFactorChecked
                            ? "#10b981"
                            : "var(--body-color-less2)",
                          borderRadius: "26px",
                          transition: "0.3s",
                        }}
                      >
                        <span
                          style={{
                            position: "absolute",
                            content: "",
                            height: "20px",
                            width: "20px",
                            left: this.state.isTwoFactorChecked
                              ? "24px"
                              : "3px",
                            bottom: "3px",
                            backgroundColor: "#fff",
                            borderRadius: "50%",
                            transition: "0.3s",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                          }}
                        ></span>
                      </span>
                    </label>
                  </div>

                  {/* Phone Auth Toggle */}
                  {/* <div
                    className="us-toggle-row"
                    style={{
                      ...settingsStyles.toggleRow,
                      marginBottom: "16px",
                    }}
                  >
                    <div>
                      <span style={settingsStyles.toggleLabel}>
                        <i
                          className="fas fa-mobile-screen"
                          style={{
                            marginRight: "8px",
                            color: "var(--btn-color)",
                          }}
                        ></i>
                        Phone Authentication at Login
                      </span>
                      <p
                        style={{
                          fontSize: "12px",
                          opacity: 0.5,
                          margin: "4px 0 0 26px",
                        }}
                      >
                        Receive SMS verification codes for login
                      </p>
                    </div>
                    <label
                      style={{
                        position: "relative",
                        display: "inline-block",
                        width: "48px",
                        height: "26px",
                        marginBottom: 0,
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={this.state.isPhoneAuthChecked}
                        onClick={this.phoneSmsAuth}
                        style={{ opacity: 0, width: 0, height: 0 }}
                      />
                      <span
                        style={{
                          position: "absolute",
                          cursor: "pointer",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          backgroundColor: this.state.isPhoneAuthChecked
                            ? "#10b981"
                            : "var(--body-color-less2)",
                          borderRadius: "26px",
                          transition: "0.3s",
                        }}
                      >
                        <span
                          style={{
                            position: "absolute",
                            content: "",
                            height: "20px",
                            width: "20px",
                            left: this.state.isPhoneAuthChecked
                              ? "24px"
                              : "3px",
                            bottom: "3px",
                            backgroundColor: "#fff",
                            borderRadius: "50%",
                            transition: "0.3s",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                          }}
                        ></span>
                      </span>
                    </label>
                  </div> */}

                  {/* Phone Number Management */}
                  <div
                    style={{
                      padding: "16px",
                      background: "var(--body-color)",
                      borderRadius: "10px",
                      border: "1px solid var(--body-color-less2)",
                    }}
                  >
                    <label
                      style={{
                        ...settingsStyles.formLabel,
                        marginBottom: "10px",
                      }}
                    >
                      <i
                        className="fas fa-phone"
                        style={{ marginRight: "6px" }}
                      ></i>{" "}
                      Phone Number
                    </label>
                    <div
                      className="us-phone-row"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        flexWrap: "wrap",
                      }}
                    >
                      <div style={{ flex: "1 1 200px" }}>
                        {!this.state.isPhoneNumberReadonly && (
                          <PhoneInput
                            placeholder="Enter phone number"
                            country={"us"}
                            value={this.state.countryCode2 + this.state.phoneNo} // 👈 FULL VALUE for UI
                            disabled={this.state.isPhoneNumberReadonly}
                            onChange={(value, countryData) => {
                              const dialCode = countryData?.dialCode || "";

                              let phoneNumber = value;

                              // Remove dial code only for storing
                              if (value.startsWith(dialCode)) {
                                phoneNumber = value.slice(dialCode.length);
                              }

                              this.setState({
                                countryCode2: dialCode,
                                phoneNo: phoneNumber,
                                sendOtpBtnForPhnoChange: phoneNumber === "",
                              });
                            }}
                            disableDropdown={false}
                            countryCodeEditable={false} // ✅ Prevent typing over country code
                            disableCountryGuess={true}
                            autoFormat={false}
                          />
                        )}
                        {this.state.isPhoneNumberReadonly && (
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: "600",
                              color: "var(--text-color)",
                            }}
                          >
                            +{this.state.countryCode}
                            {this.state.result}
                          </span>
                        )}
                      </div>
                      <div
                        className="us-phone-btns"
                        style={{ display: "flex", gap: "8px" }}
                      >
                        {this.state.permission == "WRITE" ? (
                          <button
                            type="button"
                            style={settingsStyles.btnOutline}
                            onClick={this.clearPhnoForEdit}
                            disabled={this.state.isChangePhnoBtnDisable}
                          >
                            <i className="fas fa-pen"></i> Change
                          </button>
                        ) : (
                          <button
                            type="button"
                            style={settingsStyles.btnDisabled}
                            onClick={() => {
                              showToast(
                                "error",
                                "You need write access to perform this operation"
                              );
                            }}
                            disabled
                          >
                            Change
                          </button>
                        )}
                        {this.state.permission == "WRITE" ? (
                          <button
                            type="button"
                            style={
                              this.state.sendOtpBtnForPhnoChange
                                ? settingsStyles.btnDisabled
                                : settingsStyles.btnPrimary
                            }
                            disabled={this.state.sendOtpBtnForPhnoChange}
                            onClick={this.sendOtp}
                          >
                            Save
                          </button>
                        ) : (
                          <button
                            type="button"
                            style={settingsStyles.btnDisabled}
                            disabled
                            onClick={() => {
                              showToast(
                                "error",
                                "You need write access to perform this operation"
                              );
                            }}
                          >
                            Save
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* CHANGE PASSWORD CARD */}
                <div className="us-card" style={settingsStyles.sectionCard}>
                  <div
                    className="us-section-header"
                    style={settingsStyles.sectionHeader}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      <div
                        className="us-section-icon"
                        style={settingsStyles.sectionIcon}
                      >
                        <i className="fas fa-lock"></i>
                      </div>
                      <div>
                        <h3
                          className="us-section-title"
                          style={settingsStyles.sectionTitle}
                        >
                          Change Password
                        </h3>
                        <p
                          className="us-section-desc"
                          style={settingsStyles.sectionDesc}
                        >
                          Update your account password regularly for security
                        </p>
                      </div>
                    </div>
                  </div>
                  <div style={{ maxWidth: "480px" }}>
                    <div style={{ marginBottom: "16px" }}>
                      <label style={settingsStyles.formLabel}>
                        Current Password
                      </label>
                      <input
                        type="text"
                        style={settingsStyles.formInput}
                        autoComplete="new-password"
                        value={this.state.currentPassword}
                        onChange={(e) => {
                          this.setState({ currentPassword: e.target.value });
                        }}
                      />
                    </div>
                    <div style={{ marginBottom: "16px" }}>
                      <label style={settingsStyles.formLabel}>
                        New Password
                      </label>
                      <input
                        type="password"
                        style={settingsStyles.formInput}
                        autoComplete="new-password"
                        defaultValue={this.state.newPassword}
                        onChange={(e) => {
                          this.setState({ newPassword: e.target.value });
                        }}
                      />
                    </div>
                    <div style={{ marginBottom: "16px" }}>
                      <label style={settingsStyles.formLabel}>
                        Retype Password
                      </label>
                      <input
                        type="password"
                        style={settingsStyles.formInput}
                        autoComplete="new-password"
                        defaultValue={this.state.reTypePassword}
                        onChange={(e) => {
                          this.setState({ reTypePassword: e.target.value });
                        }}
                      />
                      {this.state.newPassword != "" &&
                        this.state.reTypePassword != "" && (
                          <div style={{ marginTop: "8px" }}>
                            {this.state.newPassword ===
                            this.state.reTypePassword ? (
                              <span
                                style={{
                                  color: "#10b981",
                                  fontSize: "12px",
                                  fontWeight: "600",
                                }}
                              >
                                <i
                                  className="fas fa-check-circle"
                                  style={{ marginRight: "4px" }}
                                ></i>{" "}
                                Password Matched
                              </span>
                            ) : (
                              <span
                                style={{
                                  color: "#ef4444",
                                  fontSize: "12px",
                                  fontWeight: "600",
                                }}
                              >
                                <i
                                  className="fas fa-times-circle"
                                  style={{ marginRight: "4px" }}
                                ></i>{" "}
                                Password Mismatched
                              </span>
                            )}
                          </div>
                        )}
                    </div>
                    {this.state.newPassword === this.state.reTypePassword && (
                      <button
                        type="button"
                        style={settingsStyles.btnPrimary}
                        onClick={this.handleChangePassword}
                      >
                        <i className="fas fa-key"></i> Change Password
                      </button>
                    )}
                  </div>
                </div>
                <PaybitoCaptcha
                  ref={this.passwordChangeRecaptchaRef}
                  sitekey={CAPTCHASITEKEY}
                />

                {/* CREATE API CARD */}
                <div className="us-card" style={settingsStyles.sectionCard}>
                  <div
                    className="us-section-header"
                    style={settingsStyles.sectionHeader}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      <div
                        className="us-section-icon"
                        style={settingsStyles.sectionIcon}
                      >
                        <i className="fas fa-key"></i>
                      </div>
                      <div>
                        <h3
                          className="us-section-title"
                          style={settingsStyles.sectionTitle}
                        >
                          Create API Key
                        </h3>
                        <p
                          className="us-section-desc"
                          style={settingsStyles.sectionDesc}
                        >
                          Generate new API keys for integrations
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "12px",
                      alignItems: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    <div style={{ flex: "1 1 280px" }}>
                      <input
                        type="text"
                        style={settingsStyles.formInput}
                        placeholder="Enter API Key name"
                        value={this.state.newAPIKeyName}
                        onChange={(e) => {
                          this.setState({ newAPIKeyName: e.target.value });
                        }}
                      />
                    </div>
                    <button
                      type="button"
                      style={settingsStyles.btnPrimary}
                      onClick={this.handleAPICreate}
                    >
                      <i className="fas fa-plus"></i> Create
                    </button>
                  </div>

                  {this.state.newApiKeyGen != "" && (
                    <div
                      style={{
                        marginTop: "20px",
                        padding: "20px",
                        background:
                          "linear-gradient(135deg, color-mix(in srgb, var(--btn-color), transparent 94%), color-mix(in srgb, var(--btn-color), transparent 97%))",
                        borderRadius: "12px",
                        border:
                          "1px solid color-mix(in srgb, var(--btn-color), transparent 80%)",
                      }}
                    >
                      {/* API Key */}
                      <div style={{ marginBottom: "12px" }}>
                        <label
                          style={{
                            ...settingsStyles.formLabel,
                            fontSize: "12px",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                            opacity: 0.7,
                          }}
                        >
                          API Key
                        </label>
                        <div
                          className="us-api-key-row"
                          style={{
                            display: "flex",
                            gap: "8px",
                            alignItems: "center",
                          }}
                        >
                          <input
                            type="text"
                            style={{
                              ...settingsStyles.formInput,
                              flex: 1,
                              fontFamily: "monospace",
                              fontSize: "12px",
                            }}
                            value={this.state.newApiKeyGen}
                            readOnly
                          />
                          <button
                            style={settingsStyles.btnOutline}
                            onClick={() =>
                              this.handleCopy(this.state.newApiKeyGen)
                            }
                          >
                            <i className="fas fa-copy"></i> Copy
                          </button>
                        </div>
                      </div>

                      {/* API Secret Key */}
                      <div style={{ marginBottom: "16px" }}>
                        <label
                          style={{
                            ...settingsStyles.formLabel,
                            fontSize: "12px",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                            opacity: 0.7,
                          }}
                        >
                          API Secret Key
                        </label>
                        <div
                          className="us-api-key-row"
                          style={{
                            display: "flex",
                            gap: "8px",
                            alignItems: "center",
                          }}
                        >
                          <input
                            type="text"
                            style={{
                              ...settingsStyles.formInput,
                              flex: 1,
                              fontFamily: "monospace",
                              fontSize: "12px",
                            }}
                            value={this.state.newApiSecretKeyGen}
                            readOnly
                          />
                          <button
                            style={settingsStyles.btnOutline}
                            onClick={() =>
                              this.handleCopy(this.state.newApiSecretKeyGen)
                            }
                          >
                            <i className="fas fa-copy"></i> Copy
                          </button>
                        </div>
                      </div>

                      {/* API Permissions */}
                      <div>
                        <label
                          style={{
                            ...settingsStyles.formLabel,
                            fontSize: "12px",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                            opacity: 0.7,
                            marginBottom: "10px",
                          }}
                        >
                          Permissions
                        </label>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "8px",
                          }}
                        >
                          {[
                            { label: "Dashboard", key: "isDashboard" },
                            { label: "Products/Price", key: "isProductsPrice" },
                            { label: "Create Payment", key: "isCreatePayment" },
                            { label: "Transactions", key: "isTransactions" },
                            { label: "Settlements", key: "isSettlements" },
                            { label: "Analytics", key: "isAnalytics" },
                            { label: "Team", key: "isTeam" },
                            { label: "Payment Setup", key: "isPaymentSetup" },
                            {
                              label: "Checkout Templates",
                              key: "isCheckoutTemplates",
                            },
                            { label: "Limits", key: "isLimits" },
                            {
                              label: "Payment Tolerance",
                              key: "isPaymentTolerance",
                            },
                          ].map(({ label, key }) => (
                            <span
                              key={key}
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                                padding: "6px 12px",
                                borderRadius: "20px",
                                fontSize: "12px",
                                fontWeight: "500",
                                background: "rgba(59,130,246,0.1)",
                                border: "1px solid rgba(59,130,246,0.35)",
                                color: "#60a5fa",
                              }}
                            >
                              {label}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* ALL API KEYS CARD */}
                <div className="us-card" style={settingsStyles.sectionCard}>
                  <div
                    className="us-api-header"
                    style={{
                      ...settingsStyles.sectionHeader,
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      <div style={settingsStyles.sectionIcon}>
                        <i className="fas fa-list"></i>
                      </div>
                      <div>
                        <h3 style={settingsStyles.sectionTitle}>
                          All API Keys
                        </h3>
                        <p style={settingsStyles.sectionDesc}>
                          Manage your existing API keys
                        </p>
                      </div>
                    </div>
                    {this.state.apikeylist?.length > 0 ? (
                      <button
                        style={{
                          ...settingsStyles.btnDanger,
                          padding: "8px 16px",
                          fontSize: "12px",
                        }}
                        onClick={this.handleDeleteAllAPIs}
                      >
                        <i
                          className="fas fa-trash"
                          style={{ paddingRight: "5px" }}
                        ></i>{" "}
                        Delete All
                      </button>
                    ) : (
                      <button
                        style={{
                          ...settingsStyles.btnDisabled,
                          padding: "8px 16px",
                          fontSize: "12px",
                        }}
                        disabled
                      >
                        <i
                          className="fas fa-trash"
                          style={{ paddingRight: "5px" }}
                        ></i>{" "}
                        Delete All
                      </button>
                    )}
                  </div>

                  <div
                    className="table-responsive us-api-table-wrap"
                    style={{ borderRadius: "10px" }}
                  >
                    <table className="table" style={{ marginBottom: 0 }}>
                      <thead>
                        <tr style={{ background: "var(--body-color)" }}>
                          {[
                            "Name",
                            "ID",
                            "Public Key",
                            "Date",
                            "API Permissions",
                            "IP Access",
                            "Action",
                          ].map((h) => (
                            <th
                              key={h}
                              style={{
                                fontSize: "12px",
                                fontWeight: "600",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                                padding: "12px 16px",
                                borderBottom:
                                  "2px solid var(--body-color-less2)",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {h}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      {this.state.apikeylist.length > 0 ? (
                        <tbody>
                          {this.state.apikeylist.map((item) => (
                            <tr
                              key={item.id}
                              style={{
                                borderBottom:
                                  "1px solid var(--body-color-less2)",
                              }}
                            >
                              <td
                                style={{
                                  padding: "12px 16px",
                                  fontSize: "13px",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {item.keyName}
                              </td>
                              <td
                                style={{
                                  padding: "12px 16px",
                                  fontSize: "13px",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {item.id}
                              </td>
                              <td style={{ padding: "12px 16px" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontFamily: "monospace",
                                      fontSize: "12px",
                                      maxWidth: "180px",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      display: "inline-block",
                                    }}
                                    title={item.apiKey}
                                  >
                                    {item.apiKey}
                                  </span>
                                  <button
                                    style={{
                                      background: "transparent",
                                      border:
                                        "1px solid var(--body-color-less2)",
                                      borderRadius: "4px",
                                      padding: "2px 7px",
                                      cursor: "pointer",
                                      fontSize: "11px",
                                      color: "var(--text-color)",
                                      flexShrink: 0,
                                    }}
                                    onClick={() => this.handleCopy(item.apiKey)}
                                    title="Copy public key"
                                  >
                                    <i className="fas fa-copy"></i>
                                  </button>
                                </div>
                              </td>
                              <td
                                style={{
                                  padding: "12px 16px",
                                  fontSize: "12px",
                                  whiteSpace: "nowrap",
                                  opacity: 0.75,
                                }}
                              >
                                {item.createdOn?.split(".")[0]}
                              </td>
                              <td style={{ padding: "12px 16px" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "6px",
                                  }}
                                >
                                  {[
                                    { label: "Dashboard", key: "isDashboard" },
                                    {
                                      label: "Products/Price",
                                      key: "isProductsPrice",
                                    },
                                    {
                                      label: "Create Payment",
                                      key: "isCreatePayment",
                                    },
                                    {
                                      label: "Transactions",
                                      key: "isTransactions",
                                    },
                                    {
                                      label: "Settlements",
                                      key: "isSettlements",
                                    },
                                    { label: "Analytics", key: "isAnalytics" },
                                    { label: "Team", key: "isTeam" },
                                    {
                                      label: "Payment Setup",
                                      key: "isPaymentSetup",
                                    },
                                    {
                                      label: "Checkout Templates",
                                      key: "isCheckoutTemplates",
                                    },
                                    { label: "Limits", key: "isLimits" },
                                    {
                                      label: "Payment Tolerance",
                                      key: "isPaymentTolerance",
                                    },
                                  ].map(({ label, key }) => {
                                    const val = item[key] ?? 0;
                                    // 0 = no access, skip pill
                                    if (val === 0) return null;
                                    const isWrite = val === 2;
                                    return (
                                      <span
                                        key={key}
                                        style={{
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: "4px",
                                          padding: "3px 9px",
                                          borderRadius: "20px",
                                          fontSize: "11px",
                                          fontWeight: "500",
                                          whiteSpace: "nowrap",
                                          background: isWrite
                                            ? "rgba(139,92,246,0.12)"
                                            : "rgba(59,130,246,0.1)",
                                          border: isWrite
                                            ? "1px solid rgba(139,92,246,0.4)"
                                            : "1px solid rgba(59,130,246,0.3)",
                                          color: isWrite
                                            ? "#a78bfa"
                                            : "#60a5fa",
                                        }}
                                      >
                                        <i
                                          className={
                                            isWrite
                                              ? "fas fa-pen"
                                              : "fas fa-eye"
                                          }
                                          style={{ fontSize: "9px" }}
                                        ></i>
                                        {label}
                                        <span
                                          style={{
                                            fontSize: "9px",
                                            opacity: 0.75,
                                          }}
                                        >
                                          {isWrite ? "Write" : "Read"}
                                        </span>
                                      </span>
                                    );
                                  })}
                                </div>
                              </td>
                              <td
                                style={{
                                  padding: "12px 16px",
                                  fontSize: "13px",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {item.ipAddress}
                              </td>
                              <td style={{ padding: "12px 16px" }}>
                                <div style={{ display: "flex", gap: "6px" }}>
                                  <button
                                    style={{
                                      ...settingsStyles.btnOutline,
                                      padding: "6px 14px",
                                      fontSize: "12px",
                                    }}
                                    onClick={() =>
                                      this.setState({
                                        showEditApiModal: true,
                                        selectedApiKey: item,
                                        ipRestrictStatus:
                                          item.ipAccess === "Unrestricted"
                                            ? 0
                                            : 1,
                                        ipListTemp: item.ipAddress
                                          ? item.ipAddress.split(",")
                                          : [],
                                      })
                                    }
                                  >
                                    <i className="fas fa-pen"></i>
                                  </button>
                                  <button
                                    style={{
                                      ...settingsStyles.btnDanger,
                                      padding: "6px 14px",
                                      fontSize: "12px",
                                    }}
                                    onClick={() =>
                                      this.handleDeleteApiKey(item)
                                    }
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      ) : (
                        <tbody>
                          <tr>
                            <td
                              colSpan="7"
                              style={{
                                textAlign: "center",
                                padding: "40px 16px",
                                fontSize: "14px",
                                opacity: 0.5,
                              }}
                            >
                              <i
                                className="fas fa-key"
                                style={{
                                  fontSize: "24px",
                                  display: "block",
                                  marginBottom: "8px",
                                  opacity: 0.3,
                                }}
                              ></i>
                              No API keys added yet
                            </td>
                          </tr>
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>

                {/* DANGER ZONE - Delete Data */}
                {localStorage.getItem(SITENAMEALIAS + "_parent_merchant_id") ==
                  "0" && (
                  <div
                    className="us-danger-zone"
                    style={settingsStyles.dangerZone}
                  >
                    <div
                      className="us-danger-header"
                      style={settingsStyles.dangerHeader}
                    >
                      <div style={settingsStyles.dangerIcon}>
                        <i className="fas fa-triangle-exclamation"></i>
                      </div>
                      <div>
                        <h3
                          style={{
                            ...settingsStyles.sectionTitle,
                            color: "#ef4444",
                          }}
                        >
                          Account Deletion
                        </h3>
                        <p style={settingsStyles.sectionDesc}>
                          Permanently delete your account data. This action
                          cannot be undone.
                        </p>
                      </div>
                    </div>
                    <PaybitoCaptcha
                      ref={this.deleteRecaptchaRef}
                      sitekey={CAPTCHASITEKEY}
                    />
                    <button
                      type="button"
                      style={settingsStyles.btnDanger}
                      onClick={() => {
                        this.handleDeleteMyData();
                      }}
                    >
                      <i className="fas fa-trash"></i> Delete My Data
                    </button>
                  </div>
                )}
              </div>
            )}

            <Footer />
          </div>
          <Modal
            show={this.state.showEditApiModal}
            backdrop="static"
            keyboard={false}
            size="md"
            onHide={() => this.setState({ showEditApiModal: false })}
          >
            <Modal.Header>
              <Modal.Title>Edit API</Modal.Title>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => this.setState({ showEditApiModal: false })}
                style={{ marginLeft: "auto" }}
              >
                X
              </button>
            </Modal.Header>

            <Modal.Body>
              <div className="ml-3 mr-3">
                {/* API Name */}
                <div className="form-group">
                  <label>API Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.selectedApiKey?.keyName || ""}
                    onChange={(e) =>
                      this.setState({
                        selectedApiKey: {
                          ...this.state.selectedApiKey,
                          keyName: e.target.value,
                        },
                      })
                    }
                    maxLength={30}
                  />
                </div>

                {/* Public Key */}
                <div className="form-group">
                  <label>Public Key</label>
                  <div style={{ wordBreak: "break-all", overflowWrap: "break-word" }}>{this.state.selectedApiKey?.apiKey}</div>
                </div>

                {/* Secret Key */}
                <div className="form-group">
                  <label>Secret Key</label>
                  <div>*******************</div>
                </div>

                {/* API Permissions */}
                <div className="form-group">
                  <label>API Permissions</label>
                  <div style={{ marginLeft: "5px" }}>
                    {(() => {
                      const permissionKeys = [
                        "isDashboard",
                        "isProductsPrice",
                        "isCreatePayment",
                        "isTransactions",
                        "isSettlements",
                        "isAnalytics",
                        "isTeam",
                        "isPaymentSetup",
                        "isCheckoutTemplates",
                        "isLimits",
                        "isPaymentTolerance",
                      ];
                      const permissionLabels = [
                        { label: "Dashboard", key: "isDashboard" },
                        { label: "Products/Price", key: "isProductsPrice" },
                        { label: "Create Payment", key: "isCreatePayment" },
                        { label: "Transactions", key: "isTransactions" },
                        { label: "Settlements", key: "isSettlements" },
                        { label: "Analytics", key: "isAnalytics" },
                        { label: "Team", key: "isTeam" },
                        { label: "Payment Setup", key: "isPaymentSetup" },
                        {
                          label: "Checkout Templates",
                          key: "isCheckoutTemplates",
                        },
                        { label: "Limits", key: "isLimits" },
                        {
                          label: "Payment Tolerance",
                          key: "isPaymentTolerance",
                        },
                      ];
                      return permissionLabels.map(({ label, key }) => {
                        const val = this.state.selectedApiKey?.[key] ?? 0;
                        // 0 = no access, 1 = Read, 2 = Write
                        const isRead = val === 1;
                        const isWrite = val === 2;
                        return (
                          <div
                            key={key}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: "9px 4px",
                              borderBottom: "1px solid var(--body-color-less2)",
                            }}
                          >
                            <span
                              style={{ fontSize: "13px", fontWeight: "500" }}
                            >
                              {label}
                            </span>
                            <div style={{ display: "flex", gap: "20px" }}>
                              <label
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  margin: 0,
                                  cursor: "pointer",
                                  fontSize: "13px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={isRead}
                                  onChange={(e) => {
                                    this.setState((prev) => ({
                                      selectedApiKey: {
                                        ...prev.selectedApiKey,
                                        [key]: e.target.checked ? 1 : 0,
                                      },
                                    }));
                                  }}
                                />
                                Read
                              </label>
                              <label
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  margin: 0,
                                  cursor: "pointer",
                                  fontSize: "13px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={isWrite}
                                  onChange={(e) => {
                                    const newVal = e.target.checked ? 2 : 0;
                                    this.setState((prev) => {
                                      const updatedKey = {
                                        ...prev.selectedApiKey,
                                        [key]: newVal,
                                      };
                                      const hasWrite = permissionKeys.some(
                                        (k) => updatedKey[k] === 2
                                      );
                                      return {
                                        selectedApiKey: updatedKey,
                                        // Force restrict mode when any Write is active
                                        ipRestrictStatus: hasWrite
                                          ? 1
                                          : prev.ipRestrictStatus,
                                      };
                                    });
                                  }}
                                />
                                Write
                              </label>
                            </div>
                          </div>
                        );
                      });
                    })()}
                  </div>
                </div>

                {/* IP Access Restrictions */}
                <div className="form-group">
                  <label>
                    IP Access Restrictions
                    {(() => {
                      const permKeys = [
                        "isDashboard",
                        "isProductsPrice",
                        "isCreatePayment",
                        "isTransactions",
                        "isSettlements",
                        "isAnalytics",
                        "isTeam",
                        "isPaymentSetup",
                        "isCheckoutTemplates",
                        "isLimits",
                        "isPaymentTolerance",
                      ];
                      const hasWrite = permKeys.some(
                        (k) => this.state.selectedApiKey?.[k] === 2
                      );
                      return hasWrite ? (
                        <span style={{ color: "#ef4444" }}> * </span>
                      ) : null;
                    })()}
                    {(() => {
                      const permKeys = [
                        "isDashboard",
                        "isProductsPrice",
                        "isCreatePayment",
                        "isTransactions",
                        "isSettlements",
                        "isAnalytics",
                        "isTeam",
                        "isPaymentSetup",
                        "isCheckoutTemplates",
                        "isLimits",
                        "isPaymentTolerance",
                      ];
                      const hasWrite = permKeys.some(
                        (k) => this.state.selectedApiKey?.[k] === 2
                      );
                      return hasWrite ? (
                        <small className="text-muted ml-2">
                          (Required for Write permissions)
                        </small>
                      ) : null;
                    })()}
                  </label>
                  <div className="form-check" style={{ marginLeft: "5px" }}>
                    <input
                      className="form-check-input"
                      type="radio"
                      checked={this.state.ipRestrictStatus === 0}
                      onChange={() => this.setState({ ipRestrictStatus: 0 })}
                    />
                    <label className="form-check-label">
                      Unrestricted (Less Secure)
                    </label>
                  </div>
                  <div className="form-check" style={{ marginLeft: "5px" }}>
                    <input
                      className="form-check-input"
                      type="radio"
                      checked={this.state.ipRestrictStatus === 1}
                      onChange={() => this.setState({ ipRestrictStatus: 1 })}
                    />
                    <label className="form-check-label">
                      Restrict access to trusted IPs only (Recommended)
                    </label>
                  </div>
                </div>

                {/* IP Address List */}
                {this.state.ipRestrictStatus === 1 && (
                  <>
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter IP and press Enter"
                        onKeyUp={(e) => {
                          if (e.key === "Enter") {
                            const ip = e.target.value.trim();
                            if (ip && !this.state.ipListTemp.includes(ip)) {
                              this.setState((prevState) => ({
                                ipListTemp: [...prevState.ipListTemp, ip],
                              }));
                              e.target.value = "";
                            }
                          }
                        }}
                      />
                      <small className="text-primary">
                        Press "Enter" to add new IP address
                      </small>
                    </div>

                    <div className="form-group">
                      <ul className="list-inline">
                        {this.state.ipListTemp.map((ip) => (
                          <li
                            key={ip}
                            className="badge badge-secondary mr-2"
                            style={{ padding: "8px 10px" }}
                          >
                            {ip}{" "}
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                this.setState((prev) => ({
                                  ipListTemp: prev.ipListTemp.filter(
                                    (i) => i !== ip
                                  ),
                                }))
                              }
                            >
                              &times;
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </>
                )}
              </div>
            </Modal.Body>

            <Modal.Footer>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  // Save changes
                  console.log(
                    "Save Edit",
                    this.state.selectedApiKey,
                    this.state.ipListTemp
                  );
                  // this.setState({ showEditApiModal: false });
                  this.handleAPIEdit();
                }}
              >
                Save
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => this.setState({ showEditApiModal: false })}
              >
                Cancel
              </button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.showOrderSettingsModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header className="d-flex justify-content-center">
              <Modal.Title>Edit Order Settings</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div style={{ marginLeft: "1rem" }}>
                {/* Registered Email Option */}
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginBottom: "10px",
                    cursor: "pointer",
                  }}
                >
                  <input
                    type="radio"
                    name="notificationEmail"
                    checked={this.state.sendNotificationToRegisteredAddress}
                    onChange={() => {
                      this.setState({
                        sendNotificationToRegisteredAddress: true,
                        sendNotificationToDifferentAddress: false,
                      });
                    }}
                    style={{ margin: 0 }}
                  />
                  <span>
                    Send notification to {this.state.sendNotificationTo}
                  </span>
                </label>

                {/* Different Email Option */}
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                    marginBottom: "10px",
                  }}
                >
                  <input
                    type="radio"
                    name="notificationEmail"
                    checked={this.state.sendNotificationToDifferentAddress}
                    onChange={() => {
                      this.setState({
                        sendNotificationToDifferentAddress: true,
                        sendNotificationToRegisteredAddress: false,
                      });
                    }}
                    style={{ margin: 0 }}
                  />
                  <span>Send notification to different email address</span>
                </label>

                {/* Conditional Email Input */}
                {this.state.sendNotificationToDifferentAddress && (
                  <div style={{ marginTop: "10px" }}>
                    <label style={{ display: "block", marginBottom: "5px" }}>
                      Enter Email
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      defaultValue={this.state.newNotificationEmail}
                      onBlur={(e) => {
                        this.handleCheckEmail(e);
                      }}
                      placeholder="Enter new email address"
                    />
                  </div>
                )}
              </div>
              <div className="d-flex justify-content-center align-items-center gap-2">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.handleUpdateOrderSetting}
                >
                  Update
                </button>
                <button
                  type="button"
                  className="btn btn-secondary ml-2"
                  onClick={() => {
                    this.setState({ showOrderSettingsModal: false });
                  }}
                >
                  Cancel
                </button>
              </div>
            </Modal.Body>
          </Modal>
          <Modal
            show={this.state.showIncreaseVolumeModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header className="d-flex justify-content-center">
              <Modal.Title>Approved Volume</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="ml-4">
                <div className="mb-4">
                  <label className="text-primary mb-2">Light Plan </label>
                  <p>
                    <i className="mdi mdi-numeric-1-box text-primary mr-2"></i>
                    Total ${
                      this.getPlanDetails("Light Plan").daily_amount_cap
                    }{" "}
                    a day and{" "}
                    {this.getPlanDetails("Light Plan").monthly_transaction_cap <
                    0
                      ? "unlimited"
                      : "only " +
                        this.getPlanDetails("Light Plan")
                          .monthly_transaction_cap}{" "}
                    in a month.
                  </p>
                  {/* <p>
                    <i className="mdi mdi-numeric-2-box text-primary mr-2"></i>
                   Merchant shall be charged 2% on all transactions.
                  </p> */}
                  {this.state.isLightPlanApplied ? (
                    <span className="text-success">Activated</span>
                  ) : (
                    <button
                      onClick={() => {
                        this.setState({
                          selectedPlanIdForApply: "1",
                          showTaxModal: true,
                        });
                      }}
                      className="btn btn-primary"
                    >
                      {" "}
                      Apply
                    </button>
                  )}
                </div>
                <hr />
                <div className="mb-4">
                  <label className="text-primary mb-2">Basic Plan</label>
                  <p>
                    <i className="mdi mdi-numeric-1-box text-primary mr-2"></i>
                    Total ${
                      this.getPlanDetails("Basic Plan").daily_amount_cap
                    }{" "}
                    a day and{" "}
                    {this.getPlanDetails("Basic Plan").monthly_transaction_cap <
                    0
                      ? "unlimited"
                      : "only " +
                        this.getPlanDetails("Basic Plan")
                          .monthly_transaction_cap}{" "}
                    in a month.
                  </p>
                  {/* <p>
                    <i className="mdi mdi-numeric-2-box text-primary mr-2"></i>
                   Merchant shall be charged 2% on all transactions.
                  </p> */}
                  <p>
                    <i className="mdi mdi-numeric-2-box text-primary mr-2"></i>
                    Merchant needs Valid Govt issued Tax ID and a functioning
                    online website.
                  </p>
                  {this.state.isBasicPlanApplied ? (
                    <span className="text-success">Activated</span>
                  ) : (
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        this.setState({
                          selectedPlanIdForApply: "2",
                          showTaxModal: true,
                          showIncreaseVolumeModal: false,
                        });
                      }}
                    >
                      {" "}
                      Apply
                    </button>
                  )}
                </div>
                <hr />
                <div className="mb-4">
                  <label className="text-primary mb-2">Business Plan</label>
                  <p>
                    <i className="mdi mdi-numeric-1-box text-primary mr-2"></i>
                    Total $
                    {this.getPlanDetails("Business Plan").daily_amount_cap} a
                    day and{" "}
                    {this.getPlanDetails("Business Plan")
                      .monthly_transaction_cap < 0
                      ? "unlimited"
                      : "only " +
                        this.getPlanDetails("Business Plan")
                          .monthly_transaction_cap}{" "}
                    in a month.
                  </p>
                  {/* <p>
                    <i className="mdi mdi-numeric-2-box text-primary mr-2"></i>
                   Merchant shall be charged 2% on all transactions.
                  </p> */}
                  <p>
                    <i className="mdi mdi-numeric-2-box text-primary mr-2"></i>
                    Merchant needs to submit.
                  </p>
                  <p>
                    <i className="mdi mdi-numeric-3-box text-primary mr-2"></i>
                    Valid Govt. issued Tax Id.
                  </p>
                  <p>
                    <i className="mdi mdi-numeric-4-box text-primary mr-2"></i>
                    Principal/Director/Owner's Photo Identification.
                  </p>
                  <p>
                    <i className="mdi mdi-numeric-5-box text-primary mr-2"></i>
                    Proof of Business Address.
                  </p>
                  <p>
                    <i className="mdi mdi-numeric-6-box text-primary mr-2"></i>
                    Incorporation documents/ Business Registration.
                  </p>
                  {this.state.isBusinessPlanApplied ? (
                    <span className="text-success">Activated</span>
                  ) : (
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        this.setState({
                          selectedPlanIdForApply: "3",
                          showTaxModal: true,
                          showIncreaseVolumeModal: false,
                        });
                      }}
                    >
                      {" "}
                      Apply
                    </button>
                  )}
                </div>
                <hr />
                <div className="mb-4">
                  <label className="text-primary mb-2">Enterprise Plan</label>
                  <p>
                    <i className="mdi mdi-numeric-1-box text-primary mr-2"></i>
                    Contact us more info{" "}
                    <a herf="javascript:void(0)">
                      contact@
                      {localStorage.getItem(SITENAMEALIAS + "_exchange")}.com
                    </a>
                  </p>
                </div>
                <hr />
              </div>

              {/* <button type="button" className="btn btn-primary" onClick={this.handleUpdateOrderSetting}>Update</button> */}
              <button
                type="button"
                className="btn btn-secondary ml-4"
                onClick={() => {
                  this.setState({ showIncreaseVolumeModal: false });
                }}
              >
                Cancel
              </button>
            </Modal.Body>
          </Modal>

          {/* scaner google verification  */}
          <Modal
            show={this.state.googleAuthModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header>
              <Modal.Title>Google Authentication</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="ml-3">
                <div className="form-group">
                  <div
                    style={{
                      height: "auto",
                      margin: "10px auto",
                      maxWidth: 250,
                      width: "100%",
                    }}
                  >
                    <QRCode
                      size={256}
                      style={{
                        height: "auto",
                        maxWidth: "100%",
                        width: "100%",
                      }}
                      value={this.state.qrcodeValue}
                      viewBox={`0 0 256 256`}
                    />
                  </div>
                  <input
                    type="password"
                    value={this.state.qrcode}
                    className="form-control mb-3"
                    ref={this.qrCodeValueRef}
                    placeholder="Google Authentication Code"
                    onChange={(e) => {
                      var regex = /^[0-9\b]+$/;
                      if (e.target.value === "" || regex.test(e.target.value)) {
                        this.setState({
                          qrcode: e.target.value,
                          isInputQrCodeAvailable: false,
                        });
                      }
                    }}
                  />
                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-2">
                      <button
                        type="button"
                        className="btn btn-primary"
                        disabled={this.state.isInputQrCodeAvailable}
                        onClick={this.googleAuthOtpVerification}
                      >
                        Submit
                      </button>
                    </div>
                    <div className="col-md-2">
                      <button
                        type="button"
                        className="btn btn-secondary ml-2"
                        onClick={() => {
                          this.setState({
                            googleAuthModal: false,
                            isGoogleAuthChecked: false,
                          });
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>

          {/* SCANER FOR 2FA AUTHENTICATION */}

          {/* <Modal
            show={this.state.googleAuthenticationModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header>
              <Modal.Title>Security Authentication</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="ml-3">
                <div className="form-group">
                  <div
                    style={{
                      height: "auto",
                      margin: "10px auto",
                      maxWidth: 250,
                      width: "100%",
                    }}
                  >
                    <QRCode
                      size={256}
                      style={{
                        height: "auto",
                        maxWidth: "100%",
                        width: "100%",
                      }}
                      value={this.state.qrcodeValue}
                      viewBox={`0 0 256 256`}
                    />
                  </div>
                  <input
                    type="password"
                    value={this.state.qrcode}
                    className="form-control mb-3"
                    ref={this.qrCodeValueRef}
                    placeholder="Google Authentication Code"
                    onChange={(e) => {
                      var regex = /^[0-9\b]+$/;
                      if (e.target.value === "" || regex.test(e.target.value)) {
                        this.setState({
                          qrcode: e.target.value,
                          isInputQrCodeAvailable: false,
                        });
                      }
                    }}
                  />
                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-2">
                      <button
                        type="button"
                        className="btn btn-primary"
                        disabled={this.state.isInputQrCodeAvailable}
                        onClick={this.googleAuthOtpVerification}
                      >
                        Submit
                      </button>
                    </div>
                    <div className="col-md-2">
                      <button
                        type="button"
                        className="btn btn-secondary ml-2"
                        onClick={() => {
                          this.setState({
                            googleAuthenticationModal: false,
                            isTwoFactorChecked: false,
                          });
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal> */}

          <Modal
            show={this.state.showMerchantSettingsModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header className="d-flex justify-content-center">
              <Modal.Title className="text-center">
                Edit Merchant Settings
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="ml-3">
                <div className="form-group">
                  <label>Organization Name*</label>
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.mOrganizationName}
                    onChange={(e) => {
                      this.setState({ mOrganizationName: e.target.value });
                    }}
                    onKeyUp={this.handleOrgName}
                    placeholder="Enter Organization Name"
                  />
                  {this.state.orgNameError && (
                    <small className="text-danger">
                      Please insert valid organization name
                    </small>
                  )}
                </div>
                <div className="form-group">
                  <label>Description*</label>
                  <textarea
                    className="form-control"
                    value={this.state.mDesc}
                    onChange={(e) => {
                      this.setState({ mDesc: e.target.value });
                    }}
                    onBlur={this.handleDiscription}
                    row="2"
                    placeholder="Enter Description"
                  ></textarea>
                  {this.state.descriptionError && (
                    <small className="text-danger">
                      Please insert valid description
                    </small>
                  )}
                </div>
                <div className="form-group">
                  <label>Industry*</label>
                  <select
                    className="form-control"
                    value={this.state.selectedIndustryForMerchantEdit}
                    onChange={(e) => {
                      this.setState({
                        selectedIndustryForMerchantEdit: e.target.value,
                      });
                    }}
                  >
                    <option value="">Select Industry</option>
                    {this.state.industryList.map((i) => (
                      <option key={i.industry_id} value={i.industry_id}>
                        {i.industry_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Website*</label>
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.mWebsite}
                    onChange={(e) => {
                      this.setState({ mWebsite: e.target.value });
                    }}
                    onBlur={this.handleWebsite}
                    placeholder="Enter Website"
                  />
                  {this.state.websiteError && (
                    <small className="text-danger">
                      Please insert valid website name
                    </small>
                  )}
                </div>
                <div className="form-group">
                  <label>Support Phone*</label>
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.mSupportPhone}
                    onChange={(e) => {
                      this.setState({ mSupportPhone: e.target.value });
                    }}
                    onBlur={this.handlePhoneNumber}
                    placeholder="Enter Phone No"
                  />
                  {this.state.phoneError && (
                    <small className="text-danger">
                      Please insert valid number
                    </small>
                  )}
                </div>
                <div className="form-group">
                  <label>Preferred Contact Method</label>
                  <div>
                    {/* Email Option */}
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginBottom: "10px",
                        cursor: "pointer",
                      }}
                    >
                      <input
                        type="radio"
                        name="preferredContact"
                        checked={this.state.isPreferedEmailChecked}
                        onChange={() => {
                          this.setState({
                            isPreferedEmailChecked: true,
                            isPreferedWebsiteChecked: false,
                          });
                        }}
                        style={{ margin: 0 }}
                      />
                      <span>Email</span>
                    </label>

                    {/* Website Option */}
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        cursor: "pointer",
                      }}
                    >
                      <input
                        type="radio"
                        name="preferredContact"
                        checked={this.state.isPreferedWebsiteChecked}
                        onChange={() => {
                          this.setState({
                            isPreferedWebsiteChecked: true,
                            isPreferedEmailChecked: false,
                          });
                        }}
                        style={{ margin: 0 }}
                      />
                      <span>Website</span>
                    </label>
                  </div>
                </div>
                <div className="form-group">
                  <label>Support Email*</label>
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.mSupportEmail}
                    onChange={(e) => {
                      this.setState({ mSupportEmail: e.target.value });
                    }}
                    onBlur={this.handleEmailId}
                    placeholder="Enter Email"
                  />
                  {this.state.emailIdError && (
                    <small className="text-danger">
                      Please insert valid email
                    </small>
                  )}
                </div>
                <div className="form-group">
                  <div className=" d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      // className="form-check-input"
                      checked={this.state.isAcceptBtcAtRetailChecked}
                      onClick={(e) => {
                        this.setState({
                          isAcceptBtcAtRetailChecked:
                            !this.state.isAcceptBtcAtRetailChecked,
                        });
                      }}
                    />{" "}
                    <span>Do you accept bitcoin at a retail location?</span>
                  </div>
                </div>
                <div className="form-group">
                  <div className=" d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      // className="form-check-input"
                      checked={this.state.isDisplayAddressChecked}
                      onClick={(e) => {
                        this.setState({
                          isDisplayAddressChecked:
                            !this.state.isDisplayAddressChecked,
                        });
                      }}
                    />{" "}
                    <span>
                      Do you want to display your address on your bills?
                    </span>
                  </div>
                </div>
                <div className="form-group">
                  <div className=" d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      // className="form-check-input"
                      checked={this.state.isDifferenAddressChecked}
                      onClick={(e) => {
                        console.log(e.target.value);
                        this.setState({
                          isDifferenAddressChecked:
                            !this.state.isDifferenAddressChecked,
                        });
                      }}
                    />{" "}
                    <span>
                      Do you want to specify an address different from your
                      organisation address?
                    </span>
                  </div>
                </div>
                {this.state.isDifferenAddressChecked && (
                  <div>
                    <div className="form-group">
                      <div>
                        <label>Address Line 1*</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Address Line 1"
                          value={this.state.mAddress1}
                          onChange={(e) => {
                            this.setState({
                              mAddress1: e.target.value,
                            });
                          }}
                          onBlur={this.handleAddress1}
                        />
                        {this.state.address1_error && (
                          <small className="text-danger">
                            Please insert valid address
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="form-group">
                      <div>
                        <label>Address Line 2</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Address Line 2"
                          value={this.state.mAddress2}
                          onChange={(e) => {
                            this.setState({
                              mAddress2: e.target.value,
                            });
                          }}
                          onBlur={this.handleAddress2}
                        />
                        {this.state.address2_error && (
                          <small className="text-danger">
                            Please insert valid address
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="form-group">
                      <div>
                        <label>City*</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter City"
                          value={this.state.mCity}
                          onChange={(e) => {
                            this.setState({
                              mCity: e.target.value,
                            });
                          }}
                          onBlur={this.handleCity}
                        />
                        {this.state.cityError && (
                          <small className="text-danger">
                            Please insert valid city name
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="form-group">
                      <div>
                        <label>State*</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter State"
                          value={this.state.mState}
                          onChange={(e) => {
                            this.setState({
                              mState: e.target.value,
                            });
                          }}
                          onBlur={this.handleState}
                        />
                        {this.state.stateError && (
                          <small className="text-danger">
                            Please insert valid state
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="form-group">
                      <div>
                        <label>Zipcode*</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Zip"
                          value={this.state.mZip}
                          onChange={(e) => {
                            if (_isValidZipCode(e.target.value)) {
                              this.setState({
                                mZip: e.target.value,
                              });
                            } else {
                              e.target.value = e.target.value.slice(0, -1);
                            }
                          }}
                          onBlur={this.handleZipcode}
                        />
                        {this.state.zipcodeError && (
                          <small className="text-danger">
                            Please insert valid zipcode
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="form-group">
                      <div>
                        <label>Country*</label>
                        <select
                          id="country"
                          name="country"
                          className="form-control"
                          value={this.state.mCountry}
                          onChange={(e) => {
                            this.setState({
                              mCountry: e.target.value,
                            });
                          }}
                        >
                          <option value="Afghanistan">Afghanistan</option>
                          <option value="Åland Islands">Åland Islands</option>
                          <option value="Albania">Albania</option>
                          <option value="Algeria">Algeria</option>
                          <option value="American Samoa">American Samoa</option>
                          <option value="Andorra">Andorra</option>
                          <option value="Angola">Angola</option>
                          <option value="Anguilla">Anguilla</option>
                          <option value="Antarctica">Antarctica</option>
                          <option value="Antigua and Barbuda">
                            Antigua and Barbuda
                          </option>
                          <option value="Argentina">Argentina</option>
                          <option value="Armenia">Armenia</option>
                          <option value="Aruba">Aruba</option>
                          <option value="Australia">Australia</option>
                          <option value="Austria">Austria</option>
                          <option value="Azerbaijan">Azerbaijan</option>
                          <option value="Bahamas">Bahamas</option>
                          <option value="Bahrain">Bahrain</option>
                          <option value="Bangladesh">Bangladesh</option>
                          <option value="Barbados">Barbados</option>
                          <option value="Belarus">Belarus</option>
                          <option value="Belgium">Belgium</option>
                          <option value="Belize">Belize</option>
                          <option value="Benin">Benin</option>
                          <option value="Bermuda">Bermuda</option>
                          <option value="Bhutan">Bhutan</option>
                          <option value="Bolivia">Bolivia</option>
                          <option value="Bosnia and Herzegovina">
                            Bosnia and Herzegovina
                          </option>
                          <option value="Botswana">Botswana</option>
                          <option value="Bouvet Island">Bouvet Island</option>
                          <option value="Brazil">Brazil</option>
                          <option value="British Indian Ocean Territory">
                            British Indian Ocean Territory
                          </option>
                          <option value="Brunei Darussalam">
                            Brunei Darussalam
                          </option>
                          <option value="Bulgaria">Bulgaria</option>
                          <option value="Burkina Faso">Burkina Faso</option>
                          <option value="Burundi">Burundi</option>
                          <option value="Cambodia">Cambodia</option>
                          <option value="Cameroon">Cameroon</option>
                          <option value="Canada">Canada</option>
                          <option value="Cape Verde">Cape Verde</option>
                          <option value="Cayman Islands">Cayman Islands</option>
                          <option value="Central African Republic">
                            Central African Republic
                          </option>
                          <option value="Chad">Chad</option>
                          <option value="Chile">Chile</option>
                          <option value="China">China</option>
                          <option value="Christmas Island">
                            Christmas Island
                          </option>
                          <option value="Cocos (Keeling) Islands">
                            Cocos (Keeling) Islands
                          </option>
                          <option value="Colombia">Colombia</option>
                          <option value="Comoros">Comoros</option>
                          <option value="Congo">Congo</option>
                          <option value="Congo, The Democratic Republic of The">
                            Congo, The Democratic Republic of The
                          </option>
                          <option value="Cook Islands">Cook Islands</option>
                          <option value="Costa Rica">Costa Rica</option>
                          <option value="Cote D'ivoire">Cote D'ivoire</option>
                          <option value="Croatia">Croatia</option>
                          <option value="Cuba">Cuba</option>
                          <option value="Cyprus">Cyprus</option>
                          <option value="Czech Republic">Czech Republic</option>
                          <option value="Denmark">Denmark</option>
                          <option value="Djibouti">Djibouti</option>
                          <option value="Dominica">Dominica</option>
                          <option value="Dominican Republic">
                            Dominican Republic
                          </option>
                          <option value="Ecuador">Ecuador</option>
                          <option value="Egypt">Egypt</option>
                          <option value="El Salvador">El Salvador</option>
                          <option value="Equatorial Guinea">
                            Equatorial Guinea
                          </option>
                          <option value="Eritrea">Eritrea</option>
                          <option value="Estonia">Estonia</option>
                          <option value="Ethiopia">Ethiopia</option>
                          <option value="Falkland Islands (Malvinas)">
                            Falkland Islands (Malvinas)
                          </option>
                          <option value="Faroe Islands">Faroe Islands</option>
                          <option value="Fiji">Fiji</option>
                          <option value="Finland">Finland</option>
                          <option value="France">France</option>
                          <option value="French Guiana">French Guiana</option>
                          <option value="French Polynesia">
                            French Polynesia
                          </option>
                          <option value="French Southern Territories">
                            French Southern Territories
                          </option>
                          <option value="Gabon">Gabon</option>
                          <option value="Gambia">Gambia</option>
                          <option value="Georgia">Georgia</option>
                          <option value="Germany">Germany</option>
                          <option value="Ghana">Ghana</option>
                          <option value="Gibraltar">Gibraltar</option>
                          <option value="Greece">Greece</option>
                          <option value="Greenland">Greenland</option>
                          <option value="Grenada">Grenada</option>
                          <option value="Guadeloupe">Guadeloupe</option>
                          <option value="Guam">Guam</option>
                          <option value="Guatemala">Guatemala</option>
                          <option value="Guernsey">Guernsey</option>
                          <option value="Guinea">Guinea</option>
                          <option value="Guinea-bissau">Guinea-bissau</option>
                          <option value="Guyana">Guyana</option>
                          <option value="Haiti">Haiti</option>
                          <option value="Heard Island and Mcdonald Islands">
                            Heard Island and Mcdonald Islands
                          </option>
                          <option value="Holy See (Vatican City State)">
                            Holy See (Vatican City State)
                          </option>
                          <option value="Honduras">Honduras</option>
                          <option value="Hong Kong">Hong Kong</option>
                          <option value="Hungary">Hungary</option>
                          <option value="Iceland">Iceland</option>
                          <option value="India">India</option>
                          <option value="Indonesia">Indonesia</option>
                          <option value="Iran, Islamic Republic of">
                            Iran, Islamic Republic of
                          </option>
                          <option value="Iraq">Iraq</option>
                          <option value="Ireland">Ireland</option>
                          <option value="Isle of Man">Isle of Man</option>
                          <option value="Israel">Israel</option>
                          <option value="Italy">Italy</option>
                          <option value="Jamaica">Jamaica</option>
                          <option value="Japan">Japan</option>
                          <option value="Jersey">Jersey</option>
                          <option value="Jordan">Jordan</option>
                          <option value="Kazakhstan">Kazakhstan</option>
                          <option value="Kenya">Kenya</option>
                          <option value="Kiribati">Kiribati</option>
                          <option value="Korea, Democratic People's Republic of">
                            Korea, Democratic People's Republic of
                          </option>
                          <option value="Korea, Republic of">
                            Korea, Republic of
                          </option>
                          <option value="Kuwait">Kuwait</option>
                          <option value="Kyrgyzstan">Kyrgyzstan</option>
                          <option value="Lao People's Democratic Republic">
                            Lao People's Democratic Republic
                          </option>
                          <option value="Latvia">Latvia</option>
                          <option value="Lebanon">Lebanon</option>
                          <option value="Lesotho">Lesotho</option>
                          <option value="Liberia">Liberia</option>
                          <option value="Libyan Arab Jamahiriya">
                            Libyan Arab Jamahiriya
                          </option>
                          <option value="Liechtenstein">Liechtenstein</option>
                          <option value="Lithuania">Lithuania</option>
                          <option value="Luxembourg">Luxembourg</option>
                          <option value="Macao">Macao</option>
                          <option value="Macedonia, The Former Yugoslav Republic of">
                            Macedonia, The Former Yugoslav Republic of
                          </option>
                          <option value="Madagascar">Madagascar</option>
                          <option value="Malawi">Malawi</option>
                          <option value="Malaysia">Malaysia</option>
                          <option value="Maldives">Maldives</option>
                          <option value="Mali">Mali</option>
                          <option value="Malta">Malta</option>
                          <option value="Marshall Islands">
                            Marshall Islands
                          </option>
                          <option value="Martinique">Martinique</option>
                          <option value="Mauritania">Mauritania</option>
                          <option value="Mauritius">Mauritius</option>
                          <option value="Mayotte">Mayotte</option>
                          <option value="Mexico">Mexico</option>
                          <option value="Micronesia, Federated States of">
                            Micronesia, Federated States of
                          </option>
                          <option value="Moldova, Republic of">
                            Moldova, Republic of
                          </option>
                          <option value="Monaco">Monaco</option>
                          <option value="Mongolia">Mongolia</option>
                          <option value="Montenegro">Montenegro</option>
                          <option value="Montserrat">Montserrat</option>
                          <option value="Morocco">Morocco</option>
                          <option value="Mozambique">Mozambique</option>
                          <option value="Myanmar">Myanmar</option>
                          <option value="Namibia">Namibia</option>
                          <option value="Nauru">Nauru</option>
                          <option value="Nepal">Nepal</option>
                          <option value="Netherlands">Netherlands</option>
                          <option value="Netherlands Antilles">
                            Netherlands Antilles
                          </option>
                          <option value="New Caledonia">New Caledonia</option>
                          <option value="New Zealand">New Zealand</option>
                          <option value="Nicaragua">Nicaragua</option>
                          <option value="Niger">Niger</option>
                          <option value="Nigeria">Nigeria</option>
                          <option value="Niue">Niue</option>
                          <option value="Norfolk Island">Norfolk Island</option>
                          <option value="Northern Mariana Islands">
                            Northern Mariana Islands
                          </option>
                          <option value="Norway">Norway</option>
                          <option value="Oman">Oman</option>
                          <option value="Pakistan">Pakistan</option>
                          <option value="Palau">Palau</option>
                          <option value="Palestinian Territory, Occupied">
                            Palestinian Territory, Occupied
                          </option>
                          <option value="Panama">Panama</option>
                          <option value="Papua New Guinea">
                            Papua New Guinea
                          </option>
                          <option value="Paraguay">Paraguay</option>
                          <option value="Peru">Peru</option>
                          <option value="Philippines">Philippines</option>
                          <option value="Pitcairn">Pitcairn</option>
                          <option value="Poland">Poland</option>
                          <option value="Portugal">Portugal</option>
                          <option value="Puerto Rico">Puerto Rico</option>
                          <option value="Qatar">Qatar</option>
                          <option value="Reunion">Reunion</option>
                          <option value="Romania">Romania</option>
                          <option value="Russian Federation">
                            Russian Federation
                          </option>
                          <option value="Rwanda">Rwanda</option>
                          <option value="Saint Helena">Saint Helena</option>
                          <option value="Saint Kitts and Nevis">
                            Saint Kitts and Nevis
                          </option>
                          <option value="Saint Lucia">Saint Lucia</option>
                          <option value="Saint Pierre and Miquelon">
                            Saint Pierre and Miquelon
                          </option>
                          <option value="Saint Vincent and The Grenadines">
                            Saint Vincent and The Grenadines
                          </option>
                          <option value="Samoa">Samoa</option>
                          <option value="San Marino">San Marino</option>
                          <option value="Sao Tome and Principe">
                            Sao Tome and Principe
                          </option>
                          <option value="Saudi Arabia">Saudi Arabia</option>
                          <option value="Senegal">Senegal</option>
                          <option value="Serbia">Serbia</option>
                          <option value="Seychelles">Seychelles</option>
                          <option value="Sierra Leone">Sierra Leone</option>
                          <option value="Singapore">Singapore</option>
                          <option value="Slovakia">Slovakia</option>
                          <option value="Slovenia">Slovenia</option>
                          <option value="Solomon Islands">
                            Solomon Islands
                          </option>
                          <option value="Somalia">Somalia</option>
                          <option value="South Africa">South Africa</option>
                          <option value="South Georgia and The South Sandwich Islands">
                            South Georgia and The South Sandwich Islands
                          </option>
                          <option value="Spain">Spain</option>
                          <option value="Sri Lanka">Sri Lanka</option>
                          <option value="Sudan">Sudan</option>
                          <option value="Suriname">Suriname</option>
                          <option value="Svalbard and Jan Mayen">
                            Svalbard and Jan Mayen
                          </option>
                          <option value="Swaziland">Swaziland</option>
                          <option value="Sweden">Sweden</option>
                          <option value="Switzerland">Switzerland</option>
                          <option value="Syrian Arab Republic">
                            Syrian Arab Republic
                          </option>
                          <option value="Taiwan">Taiwan</option>
                          <option value="Tajikistan">Tajikistan</option>
                          <option value="Tanzania, United Republic of">
                            Tanzania, United Republic of
                          </option>
                          <option value="Thailand">Thailand</option>
                          <option value="Timor-leste">Timor-leste</option>
                          <option value="Togo">Togo</option>
                          <option value="Tokelau">Tokelau</option>
                          <option value="Tonga">Tonga</option>
                          <option value="Trinidad and Tobago">
                            Trinidad and Tobago
                          </option>
                          <option value="Tunisia">Tunisia</option>
                          <option value="Turkey">Turkey</option>
                          <option value="Turkmenistan">Turkmenistan</option>
                          <option value="Turks and Caicos Islands">
                            Turks and Caicos Islands
                          </option>
                          <option value="Tuvalu">Tuvalu</option>
                          <option value="Uganda">Uganda</option>
                          <option value="Ukraine">Ukraine</option>
                          <option value="United Arab Emirates">
                            United Arab Emirates
                          </option>
                          <option value="United Kingdom">United Kingdom</option>
                          <option value="United States">United States</option>
                          <option value="United States Minor Outlying Islands">
                            United States Minor Outlying Islands
                          </option>
                          <option value="Uruguay">Uruguay</option>
                          <option value="Uzbekistan">Uzbekistan</option>
                          <option value="Vanuatu">Vanuatu</option>
                          <option value="Venezuela">Venezuela</option>
                          <option value="Viet Nam">Viet Nam</option>
                          <option value="Virgin Islands, British">
                            Virgin Islands, British
                          </option>
                          <option value="Virgin Islands, U.S.">
                            Virgin Islands, U.S.
                          </option>
                          <option value="Wallis and Futuna">
                            Wallis and Futuna
                          </option>
                          <option value="Western Sahara">Western Sahara</option>
                          <option value="Yemen">Yemen</option>
                          <option value="Zambia">Zambia</option>
                          <option value="Zimbabwe">Zimbabwe</option>
                        </select>
                        {/* <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Country"
                          value={this.state.mCountry}
                          onChange={(e) => {
                            this.setState({
                              mCountry: e.target.value,
                            });
                          }}
                        /> */}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="d-flex justify-content-center align-items-center gap-2">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.handleUpdateMerchantProfileSettings}
                  disabled={this.state.btnUpdateSetting}
                >
                  Update
                </button>
                <button
                  type="button"
                  className="btn btn-secondary ml-2"
                  onClick={() => {
                    this.setState({ showMerchantSettingsModal: false });
                  }}
                >
                  Cancel
                </button>
              </div>
            </Modal.Body>
          </Modal>
          <Modal
            show={this.state.showTaxModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header>
              <Modal.Title>Tax Document</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="ml-4">
                <div className="form-group">
                  <label>EIN*</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter EIN "
                    defaultValue={this.state.ein}
                    onChange={(e) => {
                      this.setState({ ein: e.target.value });
                    }}
                  />
                </div>
                {this.state.selectedPlanIdForApply == "3" && (
                  <div className="form-group">
                    <label>Website</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Website "
                      defaultValue={this.state.website}
                      onChange={(e) => {
                        this.setState({ website: e.target.value });
                      }}
                      onBlur={this.isValidWebsite}
                    />
                    {this.state.isWebsiteError && (
                      <small className="text-danger">
                        Please insert valid website name
                      </small>
                    )}
                  </div>
                )}
                <div className="form-group">
                  <label>Please select EIN issuance document</label>
                  <input
                    type="file"
                    className="form-control"
                    defaultValue={this.state.einDoc}
                    onChange={(e) => {
                      this.setState({ einDoc: e.target.files[0] });
                    }}
                    placeholder="Select EIN Document"
                  />
                </div>
                {this.state.selectedPlanIdForApply == "3" && (
                  <div className="form-group">
                    <label>
                      Principal/Director/Owner's Photo Identification
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      defaultValue={this.state.ownerIdentityDoc}
                      onChange={(e) => {
                        this.setState({ ownerIdentityDoc: e.target.files[0] });
                      }}
                      placeholder="Select Identity Document"
                    />
                  </div>
                )}
                {this.state.selectedPlanIdForApply == "3" && (
                  <div className="form-group">
                    <label>
                      Incorporation documents/ Business Registration
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      defaultValue={this.state.inCorpDoc}
                      onChange={(e) => {
                        this.setState({ inCorpDoc: e.target.files[0] });
                      }}
                      placeholder="Select Incorporation  Document"
                    />
                  </div>
                )}
                {this.state.selectedPlanIdForApply == "3" && (
                  <div className="form-group">
                    <label>Proof of Business Address</label>
                    <input
                      type="file"
                      className="form-control"
                      defaultValue={this.state.inCorpDoc}
                      onChange={(e) => {
                        this.setState({
                          businessAddressDoc: e.target.files[0],
                        });
                      }}
                      placeholder="Select Proof of Business Address"
                    />
                  </div>
                )}
                <div className="row">
                  <div className="">
                    <button
                      className="btn btn-primary"
                      onClick={this.handleApplyPlan}
                      disabled={this.state.btnDisabled}
                    >
                      Apply
                    </button>
                  </div>
                  <div className="ml-2">
                    <button
                      className="btn btn-secondary"
                      onClick={() => {
                        this.setState({
                          showTaxModal: false,
                          showIncreaseVolumeModal: true,
                        });
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
          <Modal
            show={this.state.showAutomaticExceptionHandlingModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header className="d-flex justify-content-center">
              <Modal.Title>Automatic Exception Handling</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="ml-4">
                <div className="form-group">
                  <label>Currency</label>
                  <select
                    className="form-control"
                    value={
                      this.state.selectedCurrencyIdForAutomaticExceptionHandling
                    }
                    onChange={(e) => {
                      this.setState(
                        {
                          selectedCurrencyIdForAutomaticExceptionHandling:
                            e.target.value,
                        },
                        () => {
                          this.renderSettingsForAutomaticExceptionHandling(
                            this.state
                              .selectedCurrencyIdForAutomaticExceptionHandling
                          );
                        }
                      );
                    }}
                  >
                    {this.state.assets.map((iter) => (
                      <option key={iter.assetId} value={iter.assetId}>
                        {iter.assetCode} - {iter.assetName}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <h6>Underpayments</h6>
                  <p>
                    An invoice price automatically adjust down so it counts as
                    fully paid if the underpaid amount is within the thresholds
                    you define.
                  </p>
                  <div className="row">
                    <input
                      type="checkbox"
                      id="recurring_bill"
                      // className="ml-4"
                      checked={this.state.isAutomaticAcceptUnderpayment}
                      onChange={(e) => {
                        this.setState({
                          isAutomaticAcceptUnderpayment:
                            !this.state.isAutomaticAcceptUnderpayment,
                        });
                      }}
                    />
                    <label htmlFor="recurring_bill" className="col-md-10 mt-2">
                      Automatically accept Underpayments?
                    </label>
                  </div>
                </div>
                <div className="form-group">
                  <label>
                    Underpayment tolerance limit (in{" "}
                    {this.state.assets.length > 0
                      ? handleDynamicCurrencyDetiails(
                          this.state.assets,
                          this.state
                            .selectedCurrencyIdForAutomaticExceptionHandling
                        )["assetCode"]
                      : ""}
                    )
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter Underpayment tolerance limit"
                    value={this.state.underPaymentToleranceLimit}
                    onChange={(e) => {
                      this.setState({
                        underPaymentToleranceLimit: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="form-group">
                  <h6>Overpayments</h6>
                  <p>
                    If a customer overpays Blockchain can automatically credit
                    the extra funds to your ledger if the overpayed amount is
                    less than the percent threshold.
                  </p>
                  <div className="row">
                    <input
                      type="checkbox"
                      id="recurring_bill"
                      // className="ml-4"
                      checked={this.state.isAutomaticAcceptOverpayment}
                      onChange={(e) => {
                        this.setState({
                          isAutomaticAcceptOverpayment:
                            !this.state.isAutomaticAcceptOverpayment,
                        });
                      }}
                    />
                    <label htmlFor="recurring_bill" className="col-md-10 mt-2">
                      Automatically accept Overpayments?
                    </label>
                  </div>
                </div>
                <div className="form-group">
                  <label>
                    Overpayments tolerance limit (in{" "}
                    {this.state.assets.length > 0
                      ? handleDynamicCurrencyDetiails(
                          this.state.assets,
                          this.state
                            .selectedCurrencyIdForAutomaticExceptionHandling
                        )["assetCode"]
                      : ""}
                    )
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter Overpayments tolerance limit"
                    value={this.state.overPaymentToleranceLimit}
                    onChange={(e) => {
                      this.setState({
                        overPaymentToleranceLimit: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="d-flex justify-content-center align-items-center gap-2">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      this.handleAutomaticExceptionHandling();
                    }}
                    disabled={
                      this.state.overPaymentToleranceLimit == "" &&
                      this.state.isAutomaticAcceptOverpayment == false &&
                      this.state.underPaymentToleranceLimit == "" &&
                      this.state.isAutomaticAcceptUnderpayment == false
                    }
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary ml-2"
                    onClick={() => {
                      this.setState({
                        showAutomaticExceptionHandlingModal: false,
                      });
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </Modal.Body>
          </Modal>

          <Modal
            show={this.state.showChangePasswordAuthModal}
            backdrop="static"
            keyboard={false}
          >
            {/* Change password security checking modal */}
            <Modal.Header>
              <Modal.Title> Security Authentication</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form className="forms-sample">
                <div className="form-group">
                  <label>Input otp from your google authenticator</label>
                  <div className="row">
                    <div className="col-md-8 pl-0">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Email google authenticator OTP"
                        ref={this.changePasswordAuthCodeRef}
                        value={this.state.changePasswordAuthCode}
                        onChange={function (e) {
                          this.setState({
                            changePasswordAuthCode: e.target.value,
                            isChangePswdAuthCodeBtn:
                              !this.state.isChangePswdAuthCodeBtn,
                          });
                        }.bind(this)}
                        onKeyUp={function (e) {
                          let elmVal = e.target.value;
                          let regex = /^[0-9]{6,6}$/;
                          if (regex.test(elmVal)) {
                            this.setState({
                              isChangePswdAuthCodeBtn: false,
                            });
                          } else {
                            this.setState({
                              isChangePswdAuthCodeBtn: true,
                            });
                          }
                        }.bind(this)}
                      />
                    </div>
                    {/* <div className="col-md-4 pl-0">
                      <button
                        type="button"
                        className="btn btn-primary mt-1"
                        onClick={this.sendOtpForChangePassword}
                        disabled={this.state.sendChangePswdOtpBtn}
                      >
                        {this.state.sendChangePswdOtpBtn
                          ? "OTP Sent"
                          : "Resend OTP"}
                      </button>
                    </div> */}
                    {/* <div className="col-md-12">
                      {this.state.showChangePswdOtpTimer && (
                        <p className="text-center">
                          Resend OTP in {this.state.changePswdOtpTimerTxt}s
                        </p>
                      )}
                    </div> */}
                  </div>
                </div>
                <div className="form-group col-12 pl-0">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.isPasswordAuthCheck}
                    disabled={this.state.isChangePswdAuthCodeBtn}
                  >
                    Confirm
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary ml-2"
                    onClick={() => {
                      this.setState({
                        showChangePasswordAuthModal: false,
                        changePasswordAuthCode: "",
                      });
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </Modal.Body>
          </Modal>

          {/* VERIFICATION THROUGH OLD REGISTRED NO */}
          <Modal
            show={this.state.changePhnoModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header>
              <Modal.Title>Change Phone Number</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form className="forms-sample">
                <div className="form-group mb-2">
                  <label>
                    Input otp from your <b>registered phone number</b>
                  </label>
                  <p>
                    We sent a text message to you at{" "}
                    {localStorage.getItem(SITENAMEALIAS + "_registredphno")}.
                    Enter the seven digit code in that message to confirm your
                    phone number.
                  </p>
                  <div className="row">
                    <div className="col-md-8 pl-0">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="OTP"
                        ref={this.registeredPhnoOtpRef}
                        value={this.state.registeredPhnoOtp}
                        onChange={(e) => {
                          this.setState({
                            registeredPhnoOtp: e.target.value,
                          });
                        }}
                        // value={this.state.changePasswordAuthCode}
                        // onChange={function (e) {
                        //   this.setState({
                        //     changePasswordAuthCode: e.target.value,
                        //     isChangePswdAuthCodeBtn:
                        //       !this.state.isChangePswdAuthCodeBtn,
                        //   });
                        // }.bind(this)}
                        // onKeyUp={function (e) {
                        //   let elmVal = e.target.value;
                        //   let regex = /^[0-9]{6,6}$/;
                        //   if (regex.test(elmVal)) {

                        //   } else {

                        //     // e.target.value = e.target.value.slice(0, -1);
                        //   }
                        // }.bind(this)}
                      />
                    </div>
                    <div className="col-md-4 pl-0">
                      <button
                        type="button"
                        className="btn btn-primary mt-1"
                        onClick={this.sendOtpToRegNo}
                        disabled={this.state.sendOtpOldNo}
                      >
                        Send
                      </button>
                    </div>
                    <div className="col-md-12">
                      {this.state.showTimerForChangPhno && (
                        <p className="text-center">
                          Resend Otp in {this.state.otptimertxt}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div
                  className="form-group col-12 pl-0 mb-2"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.verifyChangeNo}
                    disabled={this.state.btnProceedToNewNo}
                  >
                    Proceed
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary ml-2"
                    onClick={() => {
                      this.setState({
                        changePhnoModal: !this.state.changePhnoModal,
                      });
                      this.registeredPhnoOtpRef.current.value = "";
                      localStorage.setItem("cdotpforchangephno", "");
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </Modal.Body>
          </Modal>

          {/* VERIFICATION THROUGH NEW NUMBER */}

          <Modal
            show={this.state.newPhnoModal}
            backdrop="static"
            keyboard={false}
          >
            {/* Change password security checking modal */}
            <Modal.Header>
              <Modal.Title>Change Phone Number</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form className="forms-sample">
                <div className="form-group mb-2">
                  <label>
                    Input otp from your <b>New phone number</b>
                  </label>
                  <p>
                    We sent a text message to you at {this.state.phoneNo}. Enter
                    the seven digit code in that message to confirm your phone
                    number.
                  </p>
                  <div className="row">
                    <div className="col-md-8">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="OTP"
                        ref={this.newPhnoOtpRef}
                        // value={this.state.changePasswordAuthCode}
                        // onChange={function (e) {
                        //   this.setState({
                        //     changePasswordAuthCode: e.target.value,
                        //     isChangePswdAuthCodeBtn:
                        //       !this.state.isChangePswdAuthCodeBtn,
                        //   });
                        // }.bind(this)}
                        // onKeyUp={function (e) {
                        //   let elmVal = e.target.value;
                        //   let regex = /^[0-9]{6,6}$/;
                        //   if (regex.test(elmVal)) {

                        //   } else {

                        //     // e.target.value = e.target.value.slice(0, -1);
                        //   }
                        // }.bind(this)}
                      />
                    </div>
                    <div className="col-md-4">
                      <button
                        type="button"
                        className="btn btn-primary mt-1"
                        onClick={this.sendOtpToNewNo}
                        disabled={this.state.sendOtpInNewnoBtn}
                      >
                        Send
                      </button>
                    </div>
                    <div className="col-md-12 mt-2">
                      {this.state.isTimerShow2 && (
                        <p className="text-center">
                          Resend Otp in {this.state.timertxt2}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div
                  className="form-group col-12 pl-0 mb-2"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <button
                    type="but ton"
                    className="btn btn-primary"
                    onClick={this.updateNewNo}
                    disabled={this.state.btnUpdateToNewNo}
                  >
                    Proceed
                  </button>
                  <button
                    type="but ton"
                    className="btn btn-secondary ml-2  "
                    onClick={() => {
                      this.setState({
                        newPhnoModal: !this.state.newPhnoModal,
                      });
                      this.newPhnoOtpRef.current.value = "";
                      localStorage.setItem("cdotpfornewphno", "");
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </Modal.Body>
          </Modal>

          {/* EMAIL UPDATE - OTP VERIFICATION MODAL */}
          <Modal
            show={this.state.emailUpdateOtpModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header className="d-flex justify-content-center">
              <Modal.Title>Update Email Address</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form className="forms-sample">
                <p>
                  We have sent OTP to both your current email (
                  <b>{localStorage.getItem(SITENAMEALIAS + "_email")}</b>) and
                  new email (<b>{this.state.newEmailForUpdate}</b>). Please
                  enter the codes below to verify.
                </p>

                {/* OLD EMAIL OTP */}
                <div className="form-group mb-3">
                  <label>
                    Input OTP from your <b>current email address</b>
                  </label>
                  <div className="row">
                    <div className="col-md-12 pl-0">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Enter OTP from current email"
                        ref={this.oldEmailOtpRef}
                        onChange={(e) => {
                          let reg = /^\d{7}$/;
                          if (e.target.value.match(reg)) {
                            this.setState({ oldEmailOtp: e.target.value });
                          } else {
                            e.target.value = e.target.value.slice(0, -1);
                            this.setState({ oldEmailOtp: e.target.value });
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* NEW EMAIL OTP */}
                <div className="form-group mb-3">
                  <label>
                    Input OTP from your <b>new email address</b>
                  </label>
                  <div className="row">
                    <div className="col-md-12 pl-0">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Enter OTP from new email"
                        ref={this.newEmailOtpRef}
                        onChange={(e) => {
                          let reg = /^\d{7}$/;
                          if (e.target.value.match(reg)) {
                            this.setState({ newEmailOtp: e.target.value });
                          } else {
                            e.target.value = e.target.value.slice(0, -1);
                            this.setState({ newEmailOtp: e.target.value });
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-12 pl-0">
                  {this.state.showOldEmailOtpTimer && (
                    <p className="text-center">
                      OTP Sent · Resend in {this.state.oldEmailOtpTimerTxt}s
                    </p>
                  )}
                  {!this.state.showOldEmailOtpTimer && (
                    <p className="text-center">
                      <button
                        type="button"
                        className="btn btn-link p-0"
                        onClick={this.resendEmailUpdateOtp}
                        disabled={this.state.sendOtpOldEmailBtn}
                      >
                        Resend OTP
                      </button>
                    </p>
                  )}
                </div>

                <div
                  className="form-group col-12 pl-0 mb-2"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.submitEmailUpdateOtp}
                  >
                    Update
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary ml-2"
                    onClick={() => {
                      this.setState({
                        emailUpdateOtpModal: false,
                      });
                      this.oldEmailOtpRef.current.value = "";
                      this.newEmailOtpRef.current.value = "";
                      localStorage.setItem("cdotpforemailupdate", "");
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </Modal.Body>
          </Modal>

          {/* PHONE AUTHENTICATION VERIFICATION USING GA OTP WHEN USER DISABLE  THE CHECKBOX */}
          <Modal
            show={this.state.showVerifyOtpModalWhilePhoneAuthDisable}
            backdrop="static"
            keyboard={false}
          >
            {/* Change password security checking modal */}
            <Modal.Header>
              <Modal.Title>SMS Authentication</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form className="forms-sample">
                <div className="form-group">
                  <label className="text-center">
                    Input OTP from google authentication app
                  </label>
                  <div className="row">
                    <div className="col-md-8">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="OTP"
                        ref={this.googleAuthOtpRef}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group col-12 pl-0">
                  <button
                    type="but ton"
                    className="btn btn-primary"
                    onClick={this.googleAuthVerify}
                  >
                    Confirm
                  </button>
                  <button type="but ton" className="btn btn-secondary ml-2  ">
                    Cancel
                  </button>
                </div>
              </form>
            </Modal.Body>
          </Modal>

          {/* EMAIL OTP SCREEN FOR FIRST TIME USER WHO ENABLE 2FA */}
          <Modal
            show={this.state.twoFaSendEmailOtpModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header>
              <Modal.Title>Security Authentication</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form className="forms-sample">
                <div className="form-group">
                  <label>Input otp from your registered email address</label>
                  <div className="row">
                    <div className="col-md-8 pl-0">
                      <input
                        type="text"
                        inputMode="numeric"
                        className="form-control"
                        placeholder="OTP"
                        title="Input must be 7 digits only"
                        value={this.state.emailOtpFor2fa}
                        ref={this.emailOtpFor2faRef}
                        onChange={(e) => {
                          let value = e.target.value.replace(/\D/g, "");
                          if (value.length <= 7) {
                            this.setState({ emailOtpFor2fa: value });
                          }
                        }}
                      />
                      {this.state.emailOtpFor2faRefError && (
                        <small className="text-danger">
                          {this.state.emailOtpFor2faRefError}
                        </small>
                      )}
                    </div>
                    <div className="col-md-4">
                      <button
                        type="button"
                        className="btn btn-primary mt-1"
                        onClick={this.sendEmailFor2fa}
                        disabled={this.state.sendEmailOtpBtn}
                      >
                        {this.state.sendEmailOtpBtn ? "OTP Sent" : "Resend OTP"}
                      </button>
                    </div>
                    <div className="col-md-12">
                      {this.state.showEmailOtpTimer && (
                        <p className="text-center">
                          Resend Otp in {this.state.emailOtpTimerTxt}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="form-group col-12 pl-0">
                  <button
                    type="but ton"
                    className="btn btn-primary"
                    onClick={this.submit2faEmailOtp}
                    disabled={this.state.proceedEmailOtpBtn}
                  >
                    Proceed
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary ml-2 "
                    onClick={() => {
                      this.setState({
                        twoFaSendEmailOtpModal: false,
                      });
                      this.state.emailOtpFor2faRef = "";
                      localStorage.setItem("cdotpforemail2fa", "");
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </Modal.Body>
          </Modal>

          {/* SCANNER FOR 2FA IF USER ENABLE FOR FIRST TIME */}

          <Modal
            show={this.state.scannerModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header className="px-4">
              <Modal.Title>Google Authentication</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="p-3">
                <div className="row form-group">
                  <div className="col-md-12">
                    <h4 className="text-center mb-3">
                      Please do not click the back button or reload the page
                    </h4>
                  </div>
                  <div
                    className="col-md-12"
                    style={{
                      height: "auto",
                      margin: "10px auto",
                      maxWidth: 250,
                      width: "100%",
                    }}
                  >
                    <QRCode
                      size={256}
                      style={{
                        height: "auto",
                        maxWidth: "100%",
                        width: "100%",
                      }}
                      value={this.state.qrCodeValFor2fa}
                      viewBox={`0 0 256 256`}
                    />
                  </div>
                  <div className="col-md-12">
                    <p>Save this emergency recovery key</p>
                    <p>
                      If you loose access to your phone, you won't be able to
                      log in to your account without this key. Print, copy or
                      write down this key without letting anyone see it.
                    </p>
                    <p>Seriously, save this key!</p>
                  </div>
                  <div className="col-md-12 pl-0">
                    <div className="row">
                      <div className="col-md-9">
                        <p className="mt-2">
                          <b ref={this.copyTxtRef}>
                            {this.state.googleAuthKey}
                          </b>
                        </p>
                      </div>
                      <div className="col-md-2">
                        <button
                          className="btn btn-primary"
                          onClick={this.copyTextToClipboard}
                        >
                          Copy
                        </button>
                      </div>
                      <div className="col-md-1"></div>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="row mt-3">
                      <div className="col-md-12">
                        <input
                          type="password"
                          value={this.state.qrcodeval}
                          className="form-control mb-3"
                          ref={this.twofaqrcodevalue}
                          placeholder="Google Authentication Code"
                          onChange={(e) => {
                            var value = e.target.value.replace(/\D/g, "");
                            this.setState({
                              qrcodeval: value,
                              verifyQrCodeBtn: false,
                            });
                          }}
                        />
                      </div>
                      <div className="col-md-12">
                        <center>
                          <button
                            type="button"
                            className="btn btn-primary"
                            disabled={this.state.verifyQrCodeBtn}
                            onClick={this.getTwoFactorAuthVerifcation}
                          >
                            Submit
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary ml-2"
                            onClick={() => {
                              this.setState({
                                scannerModal: false,
                              });
                            }}
                          >
                            Cancel
                          </button>
                        </center>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>

          {/* SECURITY CHECKING MODAL IF USER ON / OFF 2FA */}
          <Modal
            show={this.state.twoFactorDisableModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header>
              <Modal.Title>Security Authentication</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form className="forms-sample">
                <div className="form-group">
                  <label>Input otp from your registered email address</label>
                  <div className="row">
                    <div className="col-md-8 pl-0">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="OTP"
                        ref={this.emailOtpForTwoFaOff}
                      />
                    </div>
                    <div className="col-md-4">
                      <button
                        type="button"
                        className="btn btn-primary mt-1"
                        onClick={this.sendEmailFor2fa}
                        disabled={this.state.sendEmailOtpFor2faBtn}
                      >
                        {this.state.sendEmailOtpFor2faBtn
                          ? "OTP Sent"
                          : "Resend OTP"}
                      </button>
                    </div>
                    <div className="col-md-12">
                      {this.state.showEmailOtpTimer && (
                        <p className="text-center">
                          Resend Otp in {this.state.emailOtpTimerTxt}s
                        </p>
                      )}
                    </div>
                  </div>

                  <br />
                  <label>
                    Input otp from your{" "}
                    {localStorage.getItem(SITENAMEALIAS + "_exchange")} Google
                    Authenticator
                  </label>
                  <div className="row">
                    <div className="col-md-12 pl-0">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Two-Factor Authentication Code"
                        ref={this.gaCodeFor2faOff}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group col-12 pl-0">
                  <button
                    type="but ton"
                    className="btn btn-primary"
                    onClick={this.saveTwoFactorSettingOff}
                    disabled={this.state.proceedEmailOtpBtn}
                  >
                    Confirm
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary ml-2 "
                    onClick={() => {
                      this.setState({
                        twoFactorDisableModal: false,
                      });
                      this.state.emailOtpForTwoFaOff = "";
                      this.state.gaCodeFor2faOff = "";
                      localStorage.setItem("cdotpforemail2fa", "");
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </Modal.Body>
          </Modal>

          <Modal
            show={this.state.twoFactorAPIKeyModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header>
              <Modal.Title>Security Authentication</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {/* <form className="forms-sample"> */}
              <div className="form-group">
                <label>Input otp from your registered email address</label>
                <div
                  className="row"
                  style={{ marginBottom: "13px", marginBottom: "0px" }}
                >
                  <div className="col-md-8 pl-0">
                    <input
                      type="number"
                      className="form-control"
                      placeholder="OTP"
                      ref={this.emailOtpForTwoFaOff}
                    />
                  </div>
                  <div className="col-md-4">
                    <button
                      type="button"
                      className="btn btn-primary mt-1"
                      onClick={this.sendEmailFor2fa}
                      disabled={this.state.sendEmailOtpFor2faBtn}
                    >
                      {this.state.sendEmailOtpFor2faBtn
                        ? "OTP Sent"
                        : "Resend OTP"}
                    </button>
                  </div>
                  <div className="col-md-12">
                    {this.state.showEmailOtpTimer && (
                      <p className="text-center" style={{ paddingTop: "15px" }}>
                        Resend Otp in {this.state.emailOtpTimerTxt}s
                      </p>
                    )}
                  </div>
                </div>
                <label style={{ paddingTop: "10px" }}>
                  Input otp from your{" "}
                  {localStorage.getItem(SITENAMEALIAS + "_exchange")} Google
                  Authenticator
                </label>
                <div className="row">
                  <div className="col-md-12 pl-0">
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Two-Factor Authentication Code"
                      ref={this.gaCodeFor2faOff}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group col-12 pl-0">
                <button
                  type="but ton"
                  className="btn btn-primary"
                  onClick={() => {
                    if (this.state.twoFactorAPIKeyModalStatus === "Create") {
                      this.createAPIkey();
                    }
                    if (this.state.twoFactorAPIKeyModalStatus === "Edit") {
                      this.updateApiKey();
                    }
                    if (this.state.twoFactorAPIKeyModalStatus === "Delete") {
                      this.deleteApiKeyById();
                    }
                    if (this.state.twoFactorAPIKeyModalStatus === "DeleteAll") {
                      this.deleteApiKey();
                    }
                  }}
                  // onClick={this.createAPIkey}
                  // disabled={this.state.proceedEmailOtpBtn}
                >
                  Confirm
                </button>
                <button
                  type="button"
                  className="btn btn-secondary ml-2 "
                  onClick={() => {
                    this.setState({
                      twoFactorAPIKeyModal: false,
                    });
                    this.state.emailOtpForTwoFaOff = "";
                    this.state.gaCodeFor2faOff = "";
                    localStorage.setItem("cdotpforemail2fa", "");
                  }}
                >
                  Cancel
                </button>
              </div>
              {/* </form> */}
            </Modal.Body>
          </Modal>

          <Loader show={this.state.showLoader} />
        </div>
      </Fragment>
    );
  }
}

export default UserSettings;
